// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Translations for JA
 * @file translations.ja.js
 * @description Main application translations for ja
 * @version v3.1.0
 */

import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsJa = {
                'login.title': 'ログイン',
                'login.slogan': '国境のない会話！',
                'login.username': 'ユーザー名',
                'login.password': 'パスワード',
                'login.submit': 'ログイン',
                'login.loading': '読み込み中...',
                'login.autoRegister.title': '自動登録',
                'login.autoRegister.description': 'アカウントをお持ちでない場合は、ユーザー名とパスワードを入力してください。自動的に作成されます。',
                'login.forgotPassword': 'パスワードをお忘れですか？',
                'login.passwordRecovery.title': 'パスワードの回復',
                'login.passwordRecovery.description': 'メールアドレスを入力して、回復リンクを受け取ります。',
                'login.passwordRecovery.emailLabel': 'メールアドレス',
                'login.passwordRecovery.emailPlaceholder': 'メールアドレスを入力',
                'login.passwordRecovery.emailHelp': '回復リンクがメールに送信されます',
                'login.passwordRecovery.send': '送信',
                'login.passwordRecovery.success': '回復リンクがメールに送信されました。受信トレイを確認してください。',
                'login.passwordRecovery.successTitle': 'メール送信済み',
                'login.passwordRecovery.successMessage': 'パスワードをリセットする手順を記載したメールを送信しました。\n受信トレイと迷惑メールフォルダをご確認ください。リンクが届くまで数分かかる場合があります。',
                'login.passwordRecovery.devExplanation': '開発モードではメールは受信トレイに送信されません。プレビュー用に保存されます。「メールを表示」で内容と回復リンクを確認できます。',
                'login.passwordRecovery.devSinkNotice': '⚠️ 開発モード：このメールは受信トレイに送信されていません。「メールを表示」で生成されたメッセージとリンクを開いてください。',
                'login.passwordRecovery.invalidEmail': '有効なメールアドレスを入力してください',
                'login.error.invalidPassword': '無効なパスワード',
                'common.language': '言語',
                'common.loading': '読み込み中…',
                'common.back': '戻る',
                'common.backToStart': 'ホームに戻る',
                'common.changeUser': 'ユーザーを変更',
                'common.request_id_label': 'リクエストID',
                'login.email.invalid': '有効なメールアドレスを入力してください',
                'captcha.solve': 'CAPTCHAを正しく解いてください',
                'captcha.generateError': 'CAPTCHAの生成中にエラーが発生しました。ページを再読み込みしてください。',
                'auth.require_email': '登録を完了するにはメールアドレスが必要です。メールアドレスを入力してください。',
                'auth.invalid_credentials': 'ユーザー名またはパスワードが正しくありません。',
                'auth.account_blocked': 'アカウントは非アクティブです。メールアドレスを入力して再有効化してください。',
                'auth.device_limit_reached': 'デバイス数の上限に達しました。他のデバイスでサインアウトするか、プランをアップグレードしてください。',
                'auth.login.device_limit.title': 'セッションまたはデバイス上限に達しました',
                'auth.login.device_limit.body': 'お使いのプランでは、同時にアクティブにできるセッションまたはデバイス数に上限があります。サインインするには、他のデバイスでサインアウトするか、別のアクティブなセッションを終了してから再度お試しください。',
                'auth.password_incorrect': 'パスワードが正しくありません。',
                'auth.login.password_error_title': 'パスワードが正しくありません',
                'auth.login.password_attempts_hint': 'パスワードを正しく入力できるのは3回までです。それ以上失敗すると、パスワードを再設定する必要があります。',
                'auth.login.password_attempts_exhausted_title': '試行回数の上限に達しました',
                'auth.login.password_attempts_exhausted_body': '許可された3回の試行を超えました。続行するには「パスワードをお忘れですか？」からパスワードを再設定してください。',
                'auth.login.go_to_reset_password': 'パスワード再設定へ',
                'auth.login.password_remaining_two': '残り2回です。',
                'auth.login.password_remaining_one': '残り1回です。',
                'auth.login.password_attempts_locked_inline': '試行回数の上限に達しました。パスワードを再設定してください。',
                'auth.account_inactive_email_mismatch': 'アカウントは非アクティブで、メールが一致しません。',
                'auth.captcha_failed': 'CAPTCHAが正しくありません。回答を確認してください。',
                'auth.captcha_expired': '認証の有効期限が切れました。新しい認証が自動で生成されました。',
                'auth.unauthorized': 'アクセス権限がありません。',
                'auth.generic_error': 'エラーが発生しました。もう一度お試しください。',
                'auth.method_not_allowed': '許可されていないメソッドです。',
                'auth.invalid_data': '無効なデータです。',
                'auth.credentials_required': 'ユーザー名とパスワードが必要です。',
                'auth.csrf_invalid': 'セッションが無効です。ページを再読み込みしてやり直してください。',
                'auth.username_taken': 'そのユーザー名は既に登録されています。ログインするか、別の名前を選んでください。',
                'auth.username_unavailable': 'そのユーザー名は使用できません。',
                'auth.nick_no_spaces': 'Nicknames cannot contain spaces.',
                'auth.password_too_short': 'パスワードは6文字以上必要です。',
                'auth.rate_limit': '試行回数が多すぎます。しばらく待ってから再試行してください。',
                'auth.confirm_success': 'アカウントが正常に確認されました。ログインにリダイレクトしています...',
                'auth.confirm_already_active': 'アカウントは既にアクティブです。ログインできます。',
                'auth.reset_sent': 'メールが登録されている場合、パスワードリセットの手順が送信されます。',
                'auth.reset_token_invalid': 'リンクが無効か見つかりません。',
                'auth.reset_token_expired': 'このリンクの有効期限が切れています。「パスワードを忘れた？」から新しいリンクを取得してください。',
                'auth.reset_done': 'パスワードを更新しました。ログインできます。',
                'auth.reset_fatal': '保存中にエラーが発生しました。後でもう一度お試しください。',
                'auth.password_mismatch': 'パスワードが一致しません。',
                'resetPassword.page.title': '新しいパスワード',
                'resetPassword.page.description': '新しいパスワードを入力してください（6文字以上）。',
                'resetPassword.newPassword': '新しいパスワード',
                'resetPassword.newPasswordPlaceholder': '6文字以上',
                'resetPassword.submit': 'パスワードをリセット',
                'resetPassword.success': 'パスワードを更新しました。ログインにリダイレクトしています...',
                'resetPassword.backToLogin': 'ログインに戻る',

                'account.delete.section_title': 'アカウントを削除',
                'account.delete.description': 'アカウントを削除すると、すべてのデータ、メッセージ、連絡先、設定が永久に削除されます。この操作は取り消せません。',
                'account.delete.button': 'マイアカウントを削除',
                'accountDeletion.title': 'アカウントとデータの削除',
                'accountDeletion.description': 'ArChat アカウントおよび関連データの削除を申請してください。',
                'accountDeletion.openRequest': 'アカウントとデータの削除を申請',
                'account.delete.confirm_title': 'アカウントを削除',
                'account.delete.confirm_message': '本当にアカウントを削除しますか？確認メールが受信トレイに送信されます。削除は永久かつ元に戻せません。',
                'account.delete.email_sent_title': 'メールを送信しました',
                'account.delete.email_sent': '確認メールを送信しました。受信トレイを確認し、リンクをクリックして削除を確定してください。',
                'account.delete.error': 'リクエストを処理できませんでした。もう一度お試しください。',
                'account.delete.confirm_page_title': 'アカウント削除の確認',
                'account.delete.confirm_page_desc': 'ArChatアカウントを永久に削除しようとしています。すべてのデータ、メッセージ、連絡先、設定が削除されます。この操作は取り消せません。',
                'account.delete.confirm_final_button': 'はい、マイアカウントを永久に削除します',
                'account.delete.cancel_go_back': 'キャンセルして戻る',
                'account.delete.done_title': 'アカウントを削除しました',
                'account.delete.done_message': 'アカウントは正常に削除されました。すべてのデータが削除されました。',
                'account.delete_token_expired': '削除リンクの有効期限が切れたか無効です。プロフィールから新しいリンクをリクエストしてください。',
                'account.delete_token_invalid': '削除リンクが無効か見つかりません。',
                'account.delete_email_failed': '確認メールを送信できませんでした。後でもう一度お試しください。',
                'account.delete_error': '削除の処理中にエラーが発生しました。後でもう一度お試しください。',

                'auth.register_success_email_sent': 'アカウントが作成されました。確認メールを送信しました。受信トレイ（と迷惑メールフォルダ）を確認し、リンクをクリックしてアカウントを有効にしてください。',
                'auth.register_success_email_pending': 'アカウントは作成されましたが、確認メールの送信に問題がありました。認証トークンは有効です。管理者に連絡するか、新しい確認メールをリクエストしてください。',
                'auth.email_not_verified': 'アカウントを有効にするにはメールを確認してください。',
                'auth.email_not_verified_title': 'アカウント確認待ち',
                'auth.email_send_failed': 'メールを送信できませんでした。再試行するか、メールを変更してください。',
                'auth.email_send_failed_title': 'メールを送信できませんでした',
                'auth.register.email_failed.title': 'アカウントを作成しました',
                'auth.register.email_failed.message': 'アカウントは正常に作成されましたが、確認メールの送信に問題がありました。迷惑メールフォルダを確認するか、新しいメールをリクエストしてください。',
                'auth.register.success.title': 'アカウントを作成しました',
                'auth.register.success.message': 'アカウントは正常に作成されました。確認メールを送信しました。受信トレイ（と迷惑メールフォルダ）を確認し、リンクをクリックしてアカウントを有効にしてください。',
                'auth.resend_sent': '確認メールを再送しました。',
                'auth.resend_email': 'メールを再送',
                'auth.retry_resend': '再試行',
                'auth.change_email': 'メールを変更',
                'auth.ver_email': 'メールを表示',
                'auth.already_verified': 'アカウントは既に確認済みです。',
                'auth.confirm_email_title': 'メールアドレスを確認',
                'auth.confirm_email_text': '認証リンクを送信します：',
                'auth.confirm_email_edit': '編集',
                'auth.confirm_email_confirm': '確認',
                'auth.confirm_email_typo_hint': '***@{suggestion} の間違いではありませんか？',
                'brand.slogan': '言語に関係なく理解される力',
                "brand.appName": "ArChat®",
                "brand.name": "ArChat®",
                "home.title": "ArChat®",
                'home.slogan': '言語に関係なく理解される力',
                'home.tagline': '自動翻訳付きメッセージング',
                'home.login': 'ログイン',
                'home.register': 'アカウント作成',
                'home.language': '言語',
                'terms.title': '利用規約',
                'terms.accept': '受け入れて続行',
                'terms.reject': '拒否',
                'terms.rejectShort': '同意しません',
                'terms.readAndAccept': '利用規約を読み、同意しました',
                'terms.cancel': 'キャンセル',
                'register.pageTitle': 'アカウント作成',
                'register.pageSubtitle': '情報を入力してアカウントを作成します。',
                'register.submitLabel': 'アカウント作成',
                'register.confirm_title': 'アカウントを確認',
                'register.confirm_message': '次のアカウントを作成します：',
                'register.confirm': '確認',
                'register.login_link': 'すでにアカウントをお持ちですか？',
                'register.password_hint': '6文字以上',
                'register.checking': '確認中…',
                'register.username_taken': 'このユーザー名は既に使用されています。',
                'register.available': '利用可能',
                'register.emailAlreadyExists': 'このメールアドレスは既に登録されています。',
                'register.continue': '続ける',
                'login.demo.title': 'デモアクセス',
                'login.demo.credentials': 'ユーザー: demo / パスワード: demo',
                'captcha.label': 'セキュリティ確認',
                'security.verification_title': 'セキュリティ確認',
                'security.captcha_question': '確認用の質問',
                'security.enter_answer': '答えを入力',
                'captcha.description': '数学演算を解いて、あなたが人間であることを確認してください',
                'captcha.required': '続行するにはCAPTCHAの答えを入力してください。',
                'menu.conversations': '会話',
                'menu.contacts': '連絡先',
                'menu.dashboard': 'ダッシュボード',
                'menu.profile': 'マイプロフィール',
                'menu.settings': '設定',
                'menu.help': 'ヘルプ',
                'menu.logout': 'ログアウト',
                'menu.files': 'マイファイル',
                'reviews.menu_title': 'レビュー',
                'reviews.rate_archat': 'ArChatを評価',
                'reviews.my_review': '自分のレビュー',
                'navbar.contacts': '連絡先',
                'navbar.profile': 'マイプロフィール',
                'navbar.settings': '設定',
                'navbar.logout': 'ログアウト',
                'onboarding.welcome_title': 'ArChat® へようこそ',
                'onboarding.welcome_subtitle': 'どんな相手とも、どんな言語でもコミュニケーションできます。',
                'onboarding.step1': 'ステップ 1',
                'onboarding.step1_title': 'ステップ 1',
                'onboarding.step1_description': '最初の連絡先を招待する',
                'onboarding.step2': 'ステップ 2',
                'onboarding.step2_title': 'ステップ 2',
                'onboarding.step2_description': '最初のメッセージを送信する',
                'onboarding.invite_contact': '連絡先を招待',
                'onboarding.explore_archat': 'ArChat® を見る',
                'contacts.invite_contact': '連絡先を招待',
                'contacts.no_contacts': '連絡先がありません',
                'help.view_initial_guide': '初期ガイドを見る',
                'suggestions.title': '提案',
                'suggestions.form.title': '提案のタイトル',
                'suggestions.form.message': 'アイデアを説明してください',
                'suggestions.form.submit': '提案を送信',
                'suggestions.send': '提案を送信',
                'suggestions.captcha_placeholder': '結果',
                'suggestions.cooldown': '次の提案を送信する前に {minutes} 分待つ必要があります。',
                'suggestions.success_title': '提案を送信しました',
                'suggestions.success_message': '提案は正常に送信されました。追跡番号: {id}',
                'suggestions.success': 'ご提案ありがとうございます。チームで確認いたします。',
                'suggestions.success.title': 'ご提案ありがとうございます！',
                'suggestions.success.reference': '参照番号',
                'suggestions.success.review': 'チームで内容を確認いたします。',
                'suggestions.success.email': '確認メールもお送りしました。',
                'suggestions.success.copy': 'コピー',
                'suggestions.success.copied': '参照番号をコピーしました',
                'suggestions.form.required': 'タイトルとメッセージは必須です。',
                'suggestions.error': '送信できませんでした。もう一度お試しください。',
                'profile.title': 'マイプロフィール',
                'profile.founderBadge': '創設者 #{position}/{limit}',
                'profile.founderTooltip': '創設メンバー – サブスクリプションが有効な間、終身固定価格',
                'profile.founderMember': '創設メンバー',
                'profile.founderHeaderBadge': '★ ファウンダー #{position}/150',
                'profile.camera.access_denied': 'カメラにアクセスできません。権限を確認してください。',
                'profile.edit': '編集',
                'profile.save': '変更を保存',
                'profile.save.success': 'プロフィールが正常に更新されました。',
                'profile.save.success.title': 'プロフィール更新',
                'profile.update.success.title': 'プロフィール更新',
                'profile.update.success.message': '変更を保存しました。',
                'profile.save.error': 'プロフィールを更新できませんでした。もう一度お試しください。',
                'profile.save.error.title': '保存エラー',
                'profile.cancel': 'キャンセル',
                'profile.nick': 'ユーザー名',
                'profile.nick.help': 'システム内の一意の識別子',
                'profile.name': '名',
                'profile.lastname': '姓',
                'profile.alias': 'エイリアス',
                'profile.email': 'メール',
                'profile.phone': '電話',
                'profile.language': '言語',
                'profile.country': '国',
                "profile.country.select": "国を選択してください",
                'profile.biography': '経歴',
                'bio.modal.original': '原文',
                'bio.modal.translation': '翻訳',
                'bio.modal.empty': 'この連絡先に経歴はありません。',
                'bio.modal.translating': '翻訳中...',
                'bio.modal.translation_error': '経歴を翻訳できませんでした。',
                'attachment.unnamed_file': 'ファイル',
                'auth.login_error.default_title': 'アクセスエラー',
                'auth.login_error.default_message': 'サインインできませんでした。',
                'profile.photo': 'プロフィール写真',
                'notifications.bell.aria': '通知',
                'notifications.panel.title': '通知',
                'notifications.empty': '通知はありません',
                'notifications.mark_read': '開いて既読にする',
                'billing.change_plan': 'プランを変更',
                'billing.usage.title': 'プランの使用状況',
                'billing.usage.users': 'ユーザー',
                'billing.usage.messages': 'メッセージ（今日）',
                'billing.usage.invitations': '招待（今日）',
                'billing.usage.messages_month': '今月のメッセージ',
                'billing.usage.chats': '会話',
                'billing.usage.warning': 'プランの制限に近づいています。PROにアップグレードして容量を増やしてください。',
                "plans.limit.reached": "限界に達しました — 計画を改善します",
                'profile.theme.dark': 'ダークモード',
                'profile.theme.light': 'ライトモード',
                'profile.theme.argentina': 'アルゼンチンテーマ',
                'modal.title': 'タイトル',
                'modal.success.title': '成功',
                'modal.error.title': 'エラー',
                'modal.warning.title': '警告',
                'info.title': '情報',
                'appearance.title': '外観',
                'appearance.theme.light': 'ライト',
                'appearance.theme.dark': 'ダーク',
                'theme.title': 'テーマ',
                'theme.light': 'ライト',
                'theme.dark': 'ダーク',
                'profile.photo.section': 'プロフィール写真',
                'profile.personalInfo': '個人情報',
                'profile.preferences': '設定',
                'profile.country.help': 'タイムゾーンは選択した国に応じて自動的に割り当てられます',
                'profile.lastname.placeholder': 'あなたの姓（オプション）',
                'profile.name.placeholder': 'あなたの名（オプション）',
                'profile.biography.placeholder': 'あなたについて教えてください...',
                'profile.notifications.sound': '通知音',
                'profile.notifications.sound_desc': 'メッセージや重要なアラートが届いたときに音を再生する',
                'profile.plan.title': 'サブスクリプションプラン',
                'profile.plan.current': '現在のプラン',
                'profile.plan.expires': '有効期限',
                'profile.plan.free.description': '機能が制限された無料プラン。すべての機能を制限なくお楽しみいただくには、PRO にアップグレードしてください。',
                'profile.plan.pro.description': '素晴らしい！ArChat® のすべてのプレミアム機能に完全にアクセスできます。',
                "profile.plan.upgrade.button": "PRO にアップグレード",
                'profile.plan.upgrade.hint': 'Access all features without limits',
                'profile.photo.change': 'プロフィール写真を変更',
                'message.placeholder': 'メッセージを入力...',
                'message.placeholderWithFile': 'ファイルを送信',
                "message.sent_from_country": "送信元",
                "message.sent_at_local_time": "発行者の現地時間",
                "message.timezone_label": "タイムゾーン",
                "message.context_info": "このメッセージは、送信された時点の時間コンテキストを保持します。",
                "message.context_pro_hint": "このメッセージには、Pro プランで利用できる時間と地理的なコンテキストが含まれています。",
                "message.context_pro_badge": "コンテキストプロ",
                'message.audio.transcribe': '音声を文字起こし',
                'message.audio.transcribing': '文字起こし中...',
                'message.audio.transcription': '文字起こし',
                'message.audio.error': '音声を文字起こしできませんでした',
                'attachment.title': 'ファイルを添付',
                'attachment.close': '閉じる',
                'attachment.gallery': '写真/動画ギャラリー',
                'attachment.cameraFront': 'フロントカメラ',
                'attachment.cameraBack': 'バックカメラ',
                'attachment.cameraWeb': 'ウェブカメラ',
                'attachment.recordAudio': 'マイクで音声を録音',
                'attachment.selectFile': 'ファイルを選択（音声、動画、テキスト、PDF）',
                'attachment.remove': '削除',
                'attachments.recipientFreeBlocked.title': 'プランの制限',
                'attachments.recipientFreeBlocked.sender': '相手は Free プランのため、添付ファイルを受け取れません。',
                'attachments.recipientFreeBlocked.receiver': '{senderName} が添付ファイルを送ろうとしましたが、あなたの {planName} プランでは添付を受信できません。ファイルを受け取るには上位プランへのアップグレードをおすすめします。',
                'attachments.recipientFreeBlocked.upgradeCta': 'プランをアップグレード',
                'audio.title': '音声を録音',
                'audio.close': '閉じる',
                'audio.ready': '録音準備完了',
                'audio.recording': '録音中...',
                'audio.finished': '録音完了',
                'audio.start': '録音開始',
                'audio.stop': '録音停止',
                'camera.title': 'カメラ',
                'camera.close': '閉じる',
                'camera.switch': 'カメラを切り替え',
                'camera.capture': '写真を撮る',
                'camera.loading': 'カメラを起動中...',
                'camera.retry': '再試行',
                'camera.error.access': 'カメラにアクセスできませんでした。権限を確認してください。',
                'camera.error.permission': 'カメラの権限が拒否されました。ブラウザの設定でカメラへのアクセスを許可してください。',
                'camera.error.notFound': 'カメラが見つかりませんでした。',
                'camera.error.busy': 'カメラは他のアプリケーションで使用中です。',
                'camera.error.constraint': 'カメラの制約を満たすことができません。',
                'profile.photo.take': '写真を撮る',
                'profile.photo.gallery': 'ギャラリーから選択',
                'profile.photo.uploading': '画像をアップロード中...',
                'profile.photo.upload.success': 'プロフィール写真が正常に更新されました',
                'profile.photo.upload.success.title': '写真が更新されました',
                'profile.photo.upload.error': 'プロフィール写真のアップロード中にエラーが発生しました。もう一度お試しください。',
                'profile.photo.upload.error.title': 'アップロードエラー',
                'user.default': 'ユーザー',
                'logout.title': '確認',
                'logout.confirm': 'ログアウトしてもよろしいですか?',
                'contacts.title': '連絡先',
                'contacts.search': '連絡先を検索',
                'contacts.search.placeholder': 'ニックネーム、名前、姓、国、または言語で検索...',
                'contacts.sort': '並び替え',
                'contacts.sortByName': '名前で',
                'contacts.sortByStatus': 'ステータスで',
                'contacts.sortByRecent': '最近',
                'contacts.filter': 'フィルター',
                'contacts.filterAll': 'すべて',
                'contacts.filterAvailable': '利用可能',
                'contacts.filterInvited': '招待済み',
                'contacts.filterBlocked': 'ブロック済み',
                'contacts.pending_invitations': '保留中の招待',
                'contacts.status.invitation_sent': '招待を送信しました',
                'contacts.empty': '連絡先がありません',
                'contacts.empty.title': 'まだ連絡先がありません',
                'contacts.empty.message': 'チャットを始めるには連絡先を招待または追加してください。',
                'contacts.empty.invite_button': '連絡先を招待',
                'contacts.empty.private.message': 'あなたのプロフィールは非公開です。連絡先を招待してチャットを始めましょう。',
                'contacts.empty.private.invite_button': '連絡先を招待',
                'contacts.search.no_results': '連絡先が見つかりません',
                'contacts.search.clear': 'すべて表示',
                'contacts.controls.search_placeholder': '連絡先を検索...',
                'contacts.controls.search_label': '連絡先を検索',
                'contacts.controls.sort_label': '並び替え',
                'contacts.controls.sort.name': '名前',
                'contacts.controls.sort.status': 'ステータス',
                'contacts.controls.sort.recent': '最近',
                'contacts.controls.sort.manual': '手動',
                'contacts.controls.sort.manual_drag_hint': 'ドラッグして並べ替え',
                'contacts.controls.filter_label': 'ステータス',
                'contacts.controls.filter.all': 'すべて',
                'contacts.controls.filter.available': '利用可能',
                'contacts.controls.filter.invited': '招待済み',
                'contacts.controls.filter.blocked': 'ブロック済み',
                'contacts.controls.filter.favorites': 'お気に入り',
                'contacts.nick': 'ユーザー名',
                'contacts.name': '名',
                'contacts.lastname': '姓',
                'contacts.country': '国',
                'contacts.language': '言語',
                'contacts.status': 'ステータス',
                'status.available': '利用可能',
                'status.busy': '取り込み中',
                'status.in_call': '通話中',
                'status.away': '離席中',
                'status.offline': 'オフライン',
                'status.custom': 'カスタムメッセージ',
                'status.set_title': '利用可能ステータス',
                'status.set_button': 'ステータスを変更',
                'status.placeholder': '任意メッセージ（例：会議中）',
                'contacts.status.pending_registration': '登録待ち',
                'contacts.status.registered': '招待済み - 登録済み',
                'contacts.status.ready_to_chat': 'チャット可能',
                'contacts.status.active_conversation': 'アクティブな会話',
                'contacts.invitation.pending.title': '保留中の招待',
                'contacts.invitation.pending.message': 'この招待は登録待ちです。連絡先は登録を完了するためのメールを受信します。登録後、彼らとチャットできます。',
                'contacts.error.no_registered': '連絡先はまだ登録されていません。登録が完了するまでお待ちください。',
                'contact.edit.title': '連絡先を編集',
                'contact.edit.alias.label': 'カスタムエイリアス',
                'contact.edit.alias.placeholder': '例：仕事のジョン',
                'contact.edit.alias.help': 'この名前が本名の代わりに表示されます',
                'contact.edit.nota.label': '個人メモ',
                'contact.edit.nota.placeholder': 'この連絡先についてのメモを追加...',
                'contact.edit.nota.help': 'プライベートメモはあなただけに表示されます',
                'contact.edit.error.noUser': 'エラー：ユーザーが識別されていません',
                'contact.edit.error.noContactId': 'エラー：連絡先を識別できませんでした',
                'contact.edit.error.save': '保存エラー',
                'contact.limit.title': '連絡先の上限に達しました',
                'contact.limit.message': 'FREEプランはユーザーあたり最大2件の連絡先までです。課金が有効になったらFOUNDATIONまたはPROにアップグレードして容量を増やせます。',
                'contact.edit.info.personalized': 'これらの変更はあなただけにパーソナライズされており、他のユーザーには影響しません。',
                'contact.edit.profileInfo': 'プロフィール情報',
                'export.title': '会話をエクスポート',
                'export.description': 'この会話をエクスポートする形式を選択してください:',
                'export.progress': 'エクスポート中...',
                "export.format.pdf": "PDF",
                'export.format.pdf.description': 'すべての画像とファイルを含むPDFドキュメント',
                "export.format.html": "HTML",
                'export.format.html.description': '任意のブラウザで開くことができるHTMLファイル',
                'export.info': 'エクスポートには、この会話のすべてのメッセージ、画像、ファイルが含まれます。',
                'export.pro_required.title': '会話をエクスポート',
                'export.pro_required.message': 'この機能は PRO プランで利用できます。',
                'invitation.title': 'メールで連絡先を招待',
                'invitation.modal.title': '招待を送信',
                'invitation.modal.description': 'ArChat®で誰かをチャットに招待します。招待を受け入れるためのリンクが記載されたメールが送信されます。',
                'invitation.email.label': '招待される人のメール',
                "invitation.email.placeholder": "ejemplo@email.com",
                'invitation.email.required': 'メールは必須です',
                'invitation.email.invalid': '有効なメールアドレスを入力してください',
                'invitation.language.label': '招待される人の希望言語',
                'invitation.language.help': 'メールはこの言語で送信されます',
                'invitation.mode.label': '会話モード',
                'invitation.mode.profesional': 'プロフェッショナル',
                'invitation.mode.profesional.description': '正式でプロフェッショナルな会話',
                'invitation.mode.tecnico': '技術的',
                'invitation.mode.tecnico.description': '技術的で専門的な会話',
                'invitation.mode.casual': 'カジュアル',
                'invitation.mode.casual.description': '非公式で親しみやすい会話',
                'invitation.message.label': '個人メッセージ（オプション）',
                'invitation.message.placeholder': '招待される人のための個人メッセージを書いてください...',
                'invitation.send': '招待を送信',
                'invitation.sending': '送信中...',
                'invitation.success': '招待が正常に送信されました',
                'invitation.error': '招待の送信中にエラーが発生しました',
                'invitation.error.self': '自分を招待することはできません',
                'invitation.error.duplicate': 'このメールには既に保留中の招待があります',
                'invitation.list.title': '送信した招待',
                'invitation.list.empty': '招待を送信していません',
                'invitation.list.email': 'メール',
                'invitation.list.language': '言語',
                'invitation.list.mode': 'モード',
                'invitation.list.status': 'ステータス',
                'invitation.list.created': '送信',
                'invitation.list.expires': '期限切れ',
                'invitation.list.actions': 'アクション',
                'invitation.status.pending': '保留中',
                'invitation.status.accepted': '承認済み',
                'invitation.status.expired': '期限切れ',
                'invitation.status.cancelled': 'キャンセル済み',
                'invitation.copy.link': 'リンクをコピー',
                'invitation.copy.success': 'リンクがクリップボードにコピーされました',
                'invitation.cancel': 'キャンセル',
                'invitation.cancel.confirm': 'この招待をキャンセルしてもよろしいですか？',
                'invitation.cancel.success': '招待が正常にキャンセルされました',
                'invitation.cancel.title': 'キャンセルの確認',
                'invitation.resend': 'メールを再送信',
                'invitation.resend.title': '招待を再送信',
                'invitation.resend.success': '招待メールが正常に再送信されました',
                'invitation.resend.error': '招待メールの再送信中にエラーが発生しました',
                'invitation.accept.title': '招待を受け入れる',
                'invitation.accept.description': 'ArChat®でチャットするよう招待されました',
                'invitation.accept.inviter': '招待者',
                'invitation.accept.message': '個人メッセージ',
                'invitation.accept.login': 'ログイン',
                'invitation.accept.register': '登録',
                'invitation.accept.error.invalid': '無効な招待トークン',
                'invitation.accept.error.expired': 'この招待は期限切れです',
                'invitation.accept.error.accepted': 'この招待は既に承認されています',
                'invitation.accept.error.cancelled': 'この招待はキャンセルされました',
                'invitation.accept.error.email_mismatch': 'アカウントのメールが招待メールと一致しません',
                'invitation.accept.success': '招待が承認されました。チャットにリダイレクトしています...',
                'invitations.sent.title': '送信した招待',
                'invitations.sent.empty': '保留中の招待はありません',
                'invitations.pending.title': '保留中の招待',
                'invitations.columns.email': 'メール',
                'invitations.columns.language': '言語',
                'invitations.columns.mode': 'モード',
                'invitations.columns.status': '状態',
                'invitations.columns.sentAt': '送信日時',
                'invitations.columns.actions': '操作',
                'invitations.status.pending': '保留中',
                'invitations.status.accepted': '承認済み',
                'invitations.status.cancelled': 'キャンセル済み',
                'invitations.status.expired': '期限切れ',
                'invitations.actions.cancel': 'キャンセル',
                'invitations.actions.copy': 'リンクをコピー',
                'invitations.actions.resend': 'メールを再送信',
                'profile.privacy.title': 'プライバシー',
                'profile.privacy.public_visibility': 'プロフィールを公開する',
                'profile.privacy.public_warning': 'これにより、ArChat®の任意のユーザーがあなたを見つけて会話を開始できるようになります。',
                'profile.privacy.private_info': 'あなたのプロフィールは非公開です。あなたが招待した、またはあなたを招待したユーザーのみがチャットできます。',
                'profile.privacy.private_default': 'デフォルトでは、セキュリティのため、プロフィールは非公開です。',
                'common.close': '閉じる',
                'common.cancel': 'キャンセル',
                'common.confirm': '確認',
                'common.sending': '送信中',
                'common.save': '保存',
                'common.saving': '保存中...',
                'buttons.accept': '受け入れる',
                'buttons.cancel': 'キャンセル',
                'buttons.save': '保存',
                'buttons.edit': '編集',
                'buttons.retry': '再試行',
                'buttons.confirm': '確認',
                'buttons.yes': 'はい',
                'buttons.no': 'いいえ',
                'buttons.send': '送信',
                'buttons.close': '閉じる',
                'buttons.continue': '続ける',
                'buttons.delete': '削除',
                'buttons.logout': 'ログアウト',
                'buttons.back': '戻る',
                'buttons.update': '更新',
                'buttons.upload': 'アップロード',
                'buttons.select': '選択',
                'conversation.backToContacts': '連絡先に戻る',
                'help.title': 'ArChat® ヘルプ',
                'help.what.title': 'ArChat®とは?',
                'help.what.description': 'ArChat®は、自動翻訳機能を備えたインスタントメッセージングシステムで、お好みの言語で世界中のユーザーとコミュニケーションを取ることができます。各ユーザーは自分の言語で書き、メッセージを自動的に自分の言語に翻訳して受け取ります。',
                'help.how.title': 'どのように機能しますか?',
                'help.how.step1.title': 'ログイン',
                'help.how.step1.description': 'ニックネームとパスワードを使用してシステムにアクセスします。アカウントがない場合は、自動的に作成されます。',
                'help.how.step2.title': '連絡先を探索',
                'help.how.step2.description': '"連絡先"セクションに移動して、利用可能なすべてのユーザーを表示します。名前、国、または言語で検索できます。',
                'help.how.step3.title': '会話を開始',
                'help.how.step3.description': '連絡先のステータスまたは名前をクリックして会話を開始します。システムは自動的にメッセージを翻訳します。',
                'help.how.step4.title': '書き込みと送信',
                'help.how.step4.description': 'お好みの言語でメッセージを書きます。受信者は自動的に自分の言語に翻訳されたメッセージを受け取ります。',
                'help.features.title': '主な機能',
                'help.features.translation': '🌐 言語間の自動かつ即座の翻訳',
                'help.features.status': '💬 オンラインステータス（オンライン、アイドル、おやすみモードなど）',
                'help.features.statusCustom': '💬 絵文字とカスタムメッセージ付きのカスタムステータス',
                'help.features.contacts': '👥 検索とフィルター機能付きの完全な連絡先リスト',
                'help.features.contactsMobile': '📱 完全な情報（姓、国、ステータス）を含む最適化されたモバイルビュー',
                'help.features.contactsFilter': '👁️ お気に入り以外の連絡先を表示/非表示にするボタン - リストをお気に入りのみに縮小',
                'help.features.contactAlias': '✏️ 各連絡先のカスタムエイリアスとプライベートメモ - 会話内の連絡先名をクリック',
                'help.features.themes': '🎨 2つの利用可能なテーマ：アルゼンチン（ライトブルー/白/金）、ダーク（深紫）',
                'help.features.messages': '📨 既読インジケーター付きのリアルタイムメッセージング',
                'help.features.attachments': '📎 ファイルの添付：画像、動画、音声、PDF文書',
                'help.features.camera': '📸 フロント、リアカメラ、またはウェブカメラでの写真撮影',
                'help.features.gallery': '🖼️ ギャラリーからのファイル選択',
                'help.features.compression': '🗜️ 画像の自動圧縮とサムネイル生成',
                'help.features.progress': '📊 ファイルアップロード中の進行状況バー',
                'help.features.delete': '🗑️ 自分のメッセージの削除',
                'help.features.scroll': '⬇️ 会話を開く際の最後のメッセージへの自動スクロール',
                'help.features.profile': '👤 アバター、経歴、設定を含むカスタマイズ可能なプロフィール',
                'help.features.profileEdit': '✏️ 中断のないプロフィール編集（編集中は更新されません）',
                'help.features.countries': '🌍 195以上の国の完全なリストと自動タイムゾーン選択',
                'help.features.registration': '📧 メール確認とセキュリティCAPTCHAによる登録',
                'help.features.multilanguage': '🗣️ 複数言語のサポート（スペイン語、英語、ポルトガル語、フランス語、ドイツ語、イタリア語、ロシア語、中国語、日本語、韓国語、アラビア語、ヒンディー語）',
                'help.features.audio': '🎤 自動テキスト転写付きの音声メッセージ録音',
                'help.features.speechToText': '📝 WhisperとGoogle Speech APIを使用した音声からテキストへの転写',
                'help.features.pwa': '📲 モバイルデバイスとデスクトップにインストール可能なPWAアプリケーション',
                'help.features.sync': '🔄 5秒ごとの自動メッセージ同期',
                'help.features.deleteSync': '🗑️ デバイス間で削除されたメッセージの自動同期',
                'help.features.notifications': '🔔 新しいメッセージ受信時の音声通知',
                'help.features.retranslation': '🔄 最初の試行が失敗した場合の自動メッセージ再翻訳',
                'help.features.preview': '👁️ 送信前のファイルプレビュー',
                'help.features.security': '🔒 CAPTCHA、ブラウザフィンガープリント、レート制限を備えたセキュリティシステム',
                'help.features.passwordRecovery': '🔑 メールによるパスワード回復',
                'help.features.emailConfirmation': '📧 アクティベーションリンク付きのメールによるアカウント確認',
                'help.features.invitations': '📧 プライベートメール招待 - 定義された言語とコンテキストで外部連絡先を招待',
                'help.features.invitationsManagement': '📋 完全な招待管理 - メニューから保留中の招待を一覧表示、再送信、またはキャンセル',
                'help.features.contactStatus': '🏷️ 表示可能な連絡先ステータス - 各連絡先のステータスを確認（保留中、登録済み、チャット準備完了）',
                'help.features.favorites': '⭐ お気に入りシステム - 連絡先をお気に入りとしてマークしてすばやくアクセス',
                'help.features.profilePhoto': '📸 改善されたプロフィール写真のアップロード - ギャラリーから画像を選択し、即座にプレビュー',
                'help.features.translationSender': '👁️ 送信者の翻訳表示 - メッセージが受信者の言語にどのように翻訳されたかを確認',
                'help.features.unifiedContacts': '🔗 統一された連絡先モデル - 連絡先は招待と既存の会話から派生',
                'help.features.privacy': '🔒 デフォルトでプライベートモード - あなたのプロフィールはプライベートで、直接招待を通じてのみアクセス可能',
                'help.features.export': '💾 会話のエクスポート - 画像とファイルを含む完全な会話をPDFまたはHTMLにエクスポート',
                'help.tips.title': '便利なヒント',
                'help.tips.language': '✅ プロフィールでお好みの言語を設定して、正しく翻訳されたメッセージを受信',
                'help.tips.status': '✅ オンラインステータスを更新して、他の人にあなたの利用可能性を知らせる',
                'help.tips.statusCustom': '✅ 絵文字とメッセージでカスタムステータスを作成して、現在の状態を表現',
                'help.tips.search': '✅ お気に入り（星）をマークし、「ユーザー」モーダルからユーザーをブロック',
                'help.tips.contactsFilter': '✅ 上部バーの目ボタン（👁️）を使用して、お気に入りでない連絡先を表示または非表示にする',
                'help.tips.contactAlias': '✅ 会話内の連絡先名をクリックして、カスタムエイリアスとプライベートメモを追加',
                'help.tips.avatar': '✅ 連絡先のアバターをクリックして大きな画像を表示',
                'help.tips.messages': '✅ 未読メッセージがある場合、ArChat®アイコンが点滅',
                'help.tips.attachments': '✅ クリップボタン（📎）を使用して画像、動画、音声、またはPDFを添付',
                'help.tips.camera': '✅ カメラを使用してアプリから直接写真を撮影',
                'help.tips.compression': '✅ 画像は自動的に圧縮されてスペースを節約',
                'help.tips.delete': '✅ 削除ボタンをクリックして自分のメッセージを削除できます',
                'help.tips.profile': '✅ 心配なくプロフィールを編集：編集中はシステムが更新されません',
                'help.tips.themes': '✅ 設定 > 外観からテーマを変更：アルゼンチン（ライトブルー）、ダーク（深紫）',
                'help.tips.country': '✅ プロフィールで国を選択すると、タイムゾーンが自動的に設定されます',
                'help.tips.registration': '✅ 登録時にメールを確認して、アカウントを完全に有効化',
                'help.tips.audio': '✅ マイクボタン（🎤）を使用して音声メッセージを録音 - 自動的にテキストに転写されます',
                'help.tips.install': '✅ デバイスにArChat®をPWAアプリケーションとしてインストールして、デスクトップから迅速にアクセス',
                'help.tips.sync': '✅ メッセージは5秒ごとに自動的に同期されます - 更新する必要はありません',
                'help.tips.deleteSync': '✅ メッセージを削除すると、受信者のすべてのデバイスで自動的に削除されます',
                'help.tips.notifications': '✅ 他のユーザーから新しいメッセージを受信すると、音が聞こえます',
                'help.tips.retranslation': '✅ メッセージが正しく翻訳されていない場合、システムは自動的に再翻訳を試みます',
                'help.tips.preview': '✅ 送信前にファイルをプレビューして、正しいことを確認',
                'help.tips.passwordRecovery': '✅ パスワードを忘れた場合は、ログイン時に「パスワードを忘れた？」リンクを使用',
                'help.tips.emailConfirmation': '✅ 登録後にメールを確認し、確認リンクをクリック',
                'help.tips.languageChange': '✅ フラグセレクターからいつでも言語を変更 - 即座に更新',
                'help.tips.inputFixed': '✅ PCでは、入力バーが画面の下部に固定されており、より便利です',
                'help.tips.invitations': '✅ プロフィールからメールで連絡先を招待 - 最初から言語と会話モードを定義',
                'help.tips.invitationsManagement': '✅ "送信済み招待"メニューから招待を管理 - メールを再送信するか、保留中の招待をキャンセル',
                'help.tips.contactStatus': '✅ リスト内の各連絡先のステータスを確認 - 保留中（オレンジ）、登録済み（緑）、またはアクティブな会話（青）',
                'help.tips.favorites': '✅ 星 ⭐ で連絡先をお気に入りとしてマーク - お気に入りがリストの最初に表示されます',
                'help.tips.profilePhoto': '✅ "ギャラリーから選択"からプロフィール写真をアップロード - 保存前にプレビューが表示されます',
                'help.tips.translationSender': '✅ メッセージを送信する際、翻訳パネルを展開して、受信者の言語にどのように翻訳されたかを確認',
                'help.tips.unifiedContacts': '✅ 連絡先が招待を受け入れたとき、または連絡先との会話があるときに、連絡先が自動的に表示されます',
                'help.tips.privacy': '✅ あなたのプロフィールはデフォルトでプライベートです - 他の人に見つけてもらいたい場合は、プロフィール > プライバシーで公開表示を有効にしてください',
                'help.tips.export': '✅ ヘッダーの ⬇️ ボタンを使用して完全な会話をエクスポート - すべての画像を含むPDFまたはHTMLを選択',
                'help.support.title': 'サポート',
                'help.support.description': '問題や質問がある場合は、システム管理者に連絡するか、利用可能な技術文書を確認してください。',
                'help.about.title': 'について',
                'help.about.developer': '開発者:',
                'help.about.location': 'MDQ - アルゼンチン',
                'help.about.linkedin': 'LinkedInプロフィールを表示',
                'presence.title': 'プレゼンスステータス',
                'presence.currentStatus': '現在のステータス:',
                'presence.changeStatus': 'ステータスを変更',
                'presence.status.online': 'オンライン',
                'presence.status.online.title': 'オンライン - すべての人に表示',
                'presence.status.online.description': 'オンライン: すべての連絡先に表示',
                'presence.status.idle': 'アイドル',
                'presence.status.idle.title': 'アイドル - 一時的な不在を示します',
                'presence.status.idle.description': 'アイドル: 一時的に利用できないことを示します',
                'presence.status.dnd': '応答不可',
                'presence.status.dnd.title': '応答不可 - 中断されたくないことを示します',
                'presence.status.dnd.description': '応答不可: 中断されたくないことを示す視覚的な表示',
                'presence.status.busy': '取り込み中',
                'presence.status.busy.title': '取り込み中 - 利用不可',
                'presence.status.busy.description': '取り込み中: 利用不可',
                'presence.status.offline': 'オフライン',
                'presence.status.offline.title': '切断 - オフラインとして表示',
                'presence.status.offline.description': 'オフライン: 切断として表示',
                'presence.status.custom': 'カスタム',
                'presence.status.custom.title': 'カスタム - 絵文字付きのユニークなステータス',
                'presence.status.custom.description': 'カスタム: 絵文字とオプションの有効期限付きのユニークなステータス',
                'dashboard.title': 'ダッシュボード',
                'dashboard.planUsage': 'プラン使用状況',
                'dashboard.filesSummary': 'マイファイル',
                'dashboard.promotions': 'プロモーション',
                'dashboard.sessions': 'アクティブなセッション',
                'dashboard.explore': '見る',
                'dashboard.noSessions': 'アクティブなセッションはありません',
                'dashboard.welcomeTitle': 'ArChat® へようこそ',
                'dashboard.welcomeSubtitle': 'あらゆる言語でコミュニケーション。',
                'dashboard.stepInvite': 'ステップ1：最初の連絡先を招待',
                'dashboard.stepMessage': 'ステップ2：最初のメッセージを送信',
                'dashboard.inviteContact': '連絡先を招待',
                'dashboard.exploreArChat': 'ArChat を探す',
                'dashboard.promotionsTitle': 'プロモーション',
                'dashboard.promotionsText': '紹介・特典プログラムの概要。',
                'dashboard.viewPromotions': 'プロモーションを見る',
                'dashboard.usageTitle': 'プラン利用状況',
                'dashboard.sessionsTitle': 'アクティブなセッション',
                'dashboard.sessionsEmpty': 'アクティブなセッションはありません',
                'dashboard.filesTitle': 'マイファイル',
                'dashboard.viewFiles': 'マイファイルを見る',
                'dashboard.noBlocks': '有効なブロックがありません。設定で1つ以上有効にしてください。',
                'dashboard.openSettings': '設定を開く',
                'dashboard.goToContacts': '連絡先へ',
                'dashboard.filesVisible': '表示中のファイル数',
                'dashboard.filesSampleNote': '先頭ページの件数（最大500+）。',
                'dashboard.loading': 'データを読み込み中...',
                'dashboard.error.title': 'エラー',
                'dashboard.error.load': '使用データを読み込めませんでした',
                'dashboard.error.generic': 'ダッシュボードの読み込みエラー',
                'dashboard.error.no_data': 'データを読み込めませんでした',
                'dashboard.retry': '再試行',
                'dashboard.unlimited': '無制限',
                "dashboard.plan.free": "FREE",
                "dashboard.plan.pro": "PRO",
                "dashboard.plan.enterprise": "ENTERPRISE",
                'dashboard.card.contacts': '連絡先',
                'dashboard.card.chars': '文字数',
                'dashboard.card.chars_month': '今月の文字数',
                'dashboard.card.storage': 'ストレージ',
                'dashboard.card.devices': 'アクティブなデバイス',
                'dashboard.upgrade.title': 'より多くのリソースが必要ですか？',
                'dashboard.upgrade.message': 'プランをアップグレードして、連絡先、文字数、ストレージ、アクティブデバイスを増やします。',
                'dashboard.upgrade.button': 'プランをアップグレード',
                'upgrade.title': 'プランをアップグレード',
                'upgrade.close': '閉じる',
                'upgrade.cancel': 'キャンセル',
                'upgrade.activate': 'PROプランを有効化',
                'upgrade.activating': '有効化中...',
                'upgrade.price.note': '',
                'upgrade.comparison.title': 'プラン比較',
                'upgrade.free.label': '無料プラン',
                'upgrade.free.limits.contacts': '最大2つの連絡先',
                'upgrade.free.limits.conversations': '最大2つの会話',
                'upgrade.free.limits.no_export': 'データエクスポートなし',
                'upgrade.free.limits.no_advanced': '高度な機能なし',
                'upgrade.pro.label': 'Proプラン',
                'upgrade.pro.recommended': '推奨',
                'upgrade.pro.benefits.contacts': '無制限の連絡先',
                'upgrade.pro.benefits.contacts.desc': '制限なく必要なすべての連絡先を追加',
                'upgrade.pro.benefits.conversations': '無制限の会話',
                'upgrade.pro.benefits.conversations.desc': '必要なすべてのアクティブな会話を維持',
                'upgrade.pro.benefits.export': '会話のエクスポート',
                'upgrade.pro.benefits.export.desc': '複数の形式（PDF、TXT、JSON）で会話をエクスポート',
                'upgrade.pro.benefits.notifications': '高度な通知',
                'upgrade.pro.benefits.notifications.desc': 'カスタム通知と高度な設定',
                'upgrade.pro.benefits.translation': '無制限の自動翻訳',
                'upgrade.pro.benefits.translation.desc': '使用制限なくメッセージを翻訳',
                'upgrade.pro.benefits.files': '無制限のファイル送信',
                'upgrade.pro.benefits.files.desc': '制限なく任意のサイズのファイルを共有',
                'upgrade.pro.benefits.themes': 'カスタムテーマ',
                'upgrade.pro.benefits.themes.desc': 'すべてのテーマへのアクセスと高度なカスタマイズ',
                'upgrade.pro.benefits.security': '高度なセキュリティ',
                'upgrade.pro.benefits.security.desc': '追加の保護と強化されたプライバシー機能',
                'upgrade.pro.benefits.analytics': '統計と分析',
                'upgrade.pro.benefits.analytics.desc': 'アクティビティの詳細な統計にアクセス',
                'upgrade.pro.benefits.priority': '優先サポート',
                'upgrade.pro.benefits.priority.desc': '優先的な注意と迅速な応答',
                'upgrade.enterprise.label': 'Enterpriseプラン',
                'upgrade.enterprise.benefits.contacts': '無制限の連絡先',
                'upgrade.enterprise.benefits.support': '24/7優先サポート',
                'upgrade.enterprise.benefits.custom': 'カスタムソリューション',
                'upgrade.enterprise.benefits.advanced': '高度なエンタープライズ機能',
                'upgrade.enterprise.benefits.integration': 'カスタム統合',
                'upgrade.enterprise.benefits.dedicated': '専用サポート',
                'upgrade.success.title': 'PROプランが有効化されました',
                'upgrade.success.message': 'プランがPROに更新されました。すべての無制限機能をお楽しみください。',
                'upgrade.error.title': 'PROの有効化エラー',
                'upgrade.error.message': 'プランを更新できませんでした。もう一度お試しください。',
                'upgrade.error.generic': '予期しないエラーが発生しました。もう一度お試しください。',
                'upgrade.benefits.contacts': '無制限の連絡先',
                'upgrade.benefits.contacts.desc': '制限なく必要なすべての連絡先を追加',
                'upgrade.benefits.conversations': '無制限の会話',
                'upgrade.benefits.conversations.desc': '必要なすべてのアクティブな会話を維持',
                'upgrade.benefits.export': '会話のエクスポート',
                'upgrade.benefits.export.desc': '複数の形式（PDF、TXT、JSON）で会話をエクスポート',
                'upgrade.benefits.notifications': '高度な通知',
                'upgrade.benefits.notifications.desc': 'カスタム通知と高度な設定',
                'upgrade.benefits.translation': '無制限の自動翻訳',
                'upgrade.benefits.translation.desc': '使用制限なくメッセージを翻訳',
                'upgrade.benefits.files': '無制限のファイル送信',
                'upgrade.benefits.files.desc': '制限なく任意のサイズのファイルを共有',
                'upgrade.benefits.themes': 'カスタムテーマ',
                'upgrade.benefits.themes.desc': 'すべてのテーマへのアクセスと高度なカスタマイズ',
                'upgrade.benefits.security': '高度なセキュリティ',
                'upgrade.benefits.security.desc': '追加の保護と強化されたプライバシー機能',
                'upgrade.benefits.analytics': '統計と分析',
                'upgrade.benefits.analytics.desc': 'アクティビティの詳細な統計にアクセス',
                'upgrade.benefits.priority': '優先サポート',
                'upgrade.benefits.priority.desc': '優先的な注意と迅速な応答',
                'upgrade.limits.contacts': '最大2つの連絡先',
                'upgrade.limits.conversations': '最大2つの会話',
                'upgrade.limits.no_export': 'データエクスポートなし',
                'upgrade.limits.no_advanced': '高度な機能なし',
                // API Error Messages
                'api.error.image_processing_not_available': 'サーバーで画像処理が利用できません',
                'api.error.image_functions_not_available': '画像処理機能が利用できません',
                'api.error.method_not_allowed': '許可されていないメソッド',
                'api.error.user_not_identified': 'ユーザーが識別されていません',
                'api.error.upload_file_too_large_php': 'ファイルがPHPで許可されている最大サイズを超えています',
                'api.error.upload_file_too_large_form': 'ファイルがフォームで許可されている最大サイズを超えています',
                'api.error.upload_file_partial': 'ファイルが部分的にアップロードされました',
                'api.error.upload_no_file': 'ファイルがアップロードされませんでした',
                'api.error.upload_no_temp_dir': '一時ディレクトリがありません',
                'api.error.upload_cant_write': 'ディスクへのファイル書き込みエラー',
                'api.error.upload_extension_stopped': 'PHP拡張機能がアップロードを停止しました',
                'api.error.upload_generic': 'ファイルアップロードエラー',
                'api.error.file_type_not_allowed': '許可されていないファイルタイプ。画像のみ許可されています（JPEG、PNG、GIF、WEBP）',
                'api.error.file_too_large': 'ファイルが大きすぎます（最大10MB）',
                'api.error.storage_limit_exceeded': 'ストレージ制限を超えました。プランをアップグレードして、より多くのファイルをアップロードしてください。',
                'api.error.user_not_found': 'ユーザーが見つからないか、非アクティブです',
                'api.error.image_directory_access': '画像ディレクトリへのアクセスエラー',
                'api.error.file_extension_not_allowed': '許可されていないファイル拡張子',
                'api.error.temp_file_save': '一時ファイルの保存エラー',
                'api.error.image_processing': '画像処理エラー',
                'api.error.database_update': 'データベースの更新エラー',
                'api.error.internal_server_error': '内部サーバーエラー',
                'api.error.internal_server_error_debug': '内部サーバーエラー',
                'api.error.user_id_required': 'ユーザーIDが必要です',
                'api.error.profile_not_found': 'プロフィールが見つかりません',
                'api.error.profile_load_failed': 'プロフィールの読み込みエラー',
                'api.error.invalid_data': '無効なデータ',
                'api.error.validation_errors': '検証エラー',
                'api.error.profile_update_failed': 'プロフィールを更新できませんでした',
                'api.error.profile_update_error': 'プロフィールの更新エラー',
                // API Success Messages
                'api.success.photo_updated': '写真が更新されました',
                'api.success.profile_loaded': 'プロフィールが正常に読み込まれました',
                'api.success.profile_updated': 'プロフィールが正常に更新されました',
                // Error Messages - Device Limits
                'errors.deviceLimit.title': 'デバイス制限に達しました',
                'errors.deviceLimit.solution': '続行するには、他のデバイスからログアウトするか、プランをアップグレードしてください。',
                // Error Messages - Network
                'errors.network.title': '接続エラー',
                'errors.network.message': 'サーバーに接続できませんでした。インターネット接続を確認してください。',
                // Error Messages - Server
                'errors.server.invalidResponse.title': 'サーバーエラー',
                'errors.server.invalidResponse.message': 'サーバーが無効な応答を返しました。もう一度お試しください。',
                // Error Messages - Generic
                'errors.generic.title': 'エラー',
                'errors.generic.message': 'エラーが発生しました。もう一度お試しください。',
                'errors.generic.403.title': 'アクセスエラー',
                'errors.generic.403.message': 'この操作を実行する権限がありません。',
                'errors.saas_max_users': 'プランのユーザー制限に達しました ({current}/{limit}).',
                'errors.tenant_frozen': 'テナントは一時的にブロックされています。',
                'errors.auth_invalid_credentials': 'ユーザー名またはパスワードが正しくありません。',
                'errors.accountInactive.title': 'アカウントは非アクティブです。メールを入力して再有効化してください。',
                'errors.accountInactive.activate': '今すぐ有効化',
                'errors.accountInactive.accept': '受け入れる',
                'errors.accountInactive.success': 'アカウントを再有効化しました。ログインできます。',
                'errors.accountInactive.fail': 'アカウントを再有効化できませんでした。もう一度お試しください。',
                'errors.accountInactive.completeSuccess': 'メールでアカウントを有効化しました。ログインできます。',
                'errors.accountInactive.completeFail': '有効化を完了できませんでした。メールを確認してもう一度お試しください。',
                // Plan Errors - Device Limit
                'plan.errors.deviceLimit.title': 'プラン制限に達しました',
                'plan.errors.deviceLimit.message': '現在のプランには、同時に接続できるデバイスの数に制限があります。',
                'plan.errors.deviceLimit.solution': '続行するには、他のデバイスからログアウトするか、プランをPROにアップグレードしてください。',
                // Plan Errors - Contacts Limit
                'plan.errors.contactsLimit.title': '連絡先の制限に達しました',
                'plan.errors.contactsLimit.message': '現在のプランには、保持できる連絡先の数に制限があります。',
                'plan.errors.contactsLimit.solution': 'より多くの連絡先を追加するには、プランをPROにアップグレードしてください。',
                // Plan Errors - Invitations Limit
                'plan.errors.invitationsLimit.title': '招待の制限に達しました',
                'plan.errors.invitationsLimit.message': '現在のプランには、1日に送信できる招待の数に制限があります。',
                'plan.errors.invitationsLimit.solution': 'より多くの招待を送信するには、プランをPROにアップグレードしてください。',
                // Plan Errors - Messages Limit
                'plan.errors.messagesLimit.title': 'メッセージの制限に達しました',
                'plan.errors.messagesLimit.message': '現在のプランには、1日に送信できるメッセージの数に制限があります。',
                'plan.errors.messagesLimit.solution': 'より多くのメッセージを送信するには、プランをPROにアップグレードしてください。',
                // Plan Errors - Storage Limit
                'plan.errors.storageLimit.title': 'ストレージの制限に達しました',
                'plan.errors.storageLimit.message': '現在のプランには、利用可能なストレージの量に制限があります。',
                'plan.errors.storageLimit.solution': 'より多くのストレージを取得するには、プランをPROにアップグレードしてください。',
                // Plan Errors - Upgrade Required
                'plan.errors.upgradeRequired.title': 'プランのアップグレードが必要です',
                'plan.errors.upgradeRequired.message': 'この機能には、現在のプランより上位のプランが必要です。',
                'plan.errors.upgradeRequired.solution': 'この機能にアクセスするには、プランをPROにアップグレードしてください。',
                "appearance.theme.system": "システム",
                "appearance.theme.corporate": "企業向け",
                "theme.system": "システム",
                "theme.corporate": "企業向け",
                'founder.title': 'FOUNDATION (ファウンダー)',
                'founder.subtitle': '生涯価格でプロジェクトを最初からサポート。',
                'founder.whatIs': '最初の150名がFOUNDATIONプランを割引生涯価格で利用できます。',
                'founder.howItWorks': 'ファウンダーレベルは位置（1〜150）で決まります。',
                'founder.benefitsTitle': '特典',
                'founder.benefitPrice': '$15 /月（Founder）',
                'founder.benefitFeatures': 'PROプランの全機能を含みます。',
                'founder.limit': 'ファウンダー枠は150名のみ。',
                'founder.cancelRule': '解約中はファウンダー資格を失います。',
                'founder.rejoinRule': '枠が空いた場合、再開すると自動でファウンダーに復帰できます。',
                'founder.tiers.title': 'ファウンダーレベル',
                'founder.tiers.legendary.name': 'LEGENDARY ファウンダー',
                'founder.tiers.legendary.range': '位置 1–25',
                'founder.tiers.legendary.desc': '最初にプロジェクトを支えた方。最高の歴史的優先度。',
                'founder.tiers.early.name': 'EARLY ファウンダー',
                'founder.tiers.early.range': '位置 26–75',
                'founder.tiers.early.desc': '早期サポート、特別な認定。',
                'founder.tiers.founder.name': 'ファウンダー',
                'founder.tiers.founder.range': '位置 76–150',
                'founder.tiers.founder.desc': '150枠内のファウンダー席。',
                'founder.whatIsLink': 'ファウンダーとは？',
                'founder.viewTiers': 'ファウンダーレベルを見る',
                'founder.modalClose': '閉じる',
                'founder.activeCountLabel': 'ファウンダー参加済み',
                'founder.urgency.lastSlots': '残りわずか ファウンダー枠',
                "founder.positionLabel": "創設者 #{position} / {limit}",
                'founder.leaderboard.title': 'トップファウンダー',
                "login.email.placeholder": "Ingresa tu email para confirmar tu cuenta",
                "login.email.help": "確認リンクがメールに送信されます",
                "auth.user_not_found": "ユーザーが見つかりません。",
                "auth.user_inactive": "あなたのアカウントは無効化されています。管理者に連絡してください。",
                "auth.tenant_mismatch": "あなたのアカウントはこの環境に属していません。管理者に連絡してください。",
                "auth.captcha_required": "セキュリティ検証 (CAPTCHA) を完了する必要があります。",
                "mail.send_failed": "回復メールを送信できませんでした。 SMTP 設定を確認するか、後でもう一度試してください。",
                "auth.resend_activation": "アクティベーションメールを再送信する",
                "register.creatingAccount": "アカウントを作成中…",
                "common.edit": "編集",
                "common.on": "アクティブ化された",
                "common.off": "無効",
                "common.refresh": "アップデート",
                "system.processing": "処理...",
                "captcha.incorrect": "キャプチャの答えが間違っています。",
                "captcha.placeholder": "答えを書いてください",
                "captcha.questionFormat": "{a} + {b} とは何ですか?",
                'menu.admin': '管理',
                'navbar.status': 'ステータス',
                "navbar.users": "ユーザー",
                'navbar.no_blocked_users': 'ブロックしたユーザーはいません',
                'navbar.blocked_users_title': 'ブロックしたユーザー',
                'contacts.blocked_users_title': 'ブロックしたユーザー',
                'contacts.country_label': '国',
                'contacts.not_reported': '未入力',
                "navbar.user_fallback": "ユーザーID}",
                "navbar.open_guide": "ガイド",
                "help.how_archat_works": "ArChat® の仕組み",
                "help.registration": "記録",
                "help.private_invitations": "プライベート招待状",
                "help.messaging": "メッセージング",
                "help.security": "安全",
                "invitation.quick_button": "連絡先を招待する",
                "onboarding.title": "ArChat® へようこそ",
                "onboarding.subtitle": "どの言語でも誰とでもコミュニケーションできます。",
                "onboarding.step1.label": "ステップ1",
                "onboarding.step1.text": "最初の連絡先を招待する",
                "onboarding.step2.label": "ステップ2",
                "onboarding.step2.text": "最初のメッセージを送信する",
                "onboarding.actions.invite": "連絡先を招待する",
                "onboarding.actions.explore": "ArChat® を探索する",
                'suggestions.sendSuccess': '提案が正常に送信されました。',
                'suggestions.sendError': '提案を送信できませんでした。もう一度お試しください。',
                'suggestions.sent': '提案が正常に送信されました。',
                'errors.suggestionSend': '提案を送信できませんでした。もう一度お試しください。',
                'app.install': 'ArChatをインストール',
                'menu.open': 'メニュー',
                "contacts.controls.hide_non_favorites": "お気に入り以外の連絡先を非表示にする",
                "contacts.controls.show_all": "すべての連絡先を表示",
                "common.navigation": "ナビゲーション",
                "common.favorite": "お気に入り",
                "common.block": "ブロック",
                "common.user": "ユーザー",
                "message.new": "新しいメッセージ",
                "message.edit": "メッセージを編集する",
                "message.edit.save": "編集を保存",
                "message.edit.cancel": "編集をキャンセルする",
                'message.translating': '翻訳中...',
                'message.translation_failed': '翻訳できませんでした',
                'message.not_translated': '原文',
                'message.retry_send': '再試行',
                'message.retrying': '再試行中...',
                "message.delete": "メッセージを削除する",
                'message.deleted_placeholder': 'メッセージを削除しました',
                "message.edited": "編集済み",
                "message.edited_at": "編集日",
                'message.delete_for_me.tooltip': '自分だけ削除',
                'message.delete_for_me.aria': 'このメッセージを自分だけ削除',
                'message.delete_for_me.confirm_title': 'メッセージを削除',
                'message.delete_for_me.confirm_message': 'このメッセージは自分の画面からのみ削除されます。',
                'message.delete_for_everyone.tooltip': '全員に対して削除',
                'message.delete_for_everyone.aria': 'このメッセージを全参加者に対して削除',
                'message.delete_for_everyone.confirm_title': '全員向けにメッセージを削除',
                'message.delete_for_everyone.confirm_message': 'このメッセージはあなたと相手の両方で削除されます。',
                'message.delete_for_everyone.window_expired': '削除可能時間が終了しました',
                "message.translation.show": "原文と翻訳を見る",
                "message.translation.hide": "翻訳を隠す",
                "emoji.search": "絵文字を検索",
                "emoji.close": "セレクターを閉じる",
                "captcha.refresh": "CAPTCHAを再生成する",
                'presence.unavailable': 'Status ga riyo dekinai',
                'presence.maintenance': 'Saba mentenansu-chu',
                "home.access_nav": "アプリケーションへのアクセス",
                "common.requiredFields": "すべての必須フィールドに入力します。",
                "bio.view": "略歴を見る",
                "profile.nick.readonly": "ユーザー名は変更できません",
                "profile.nick.readonly.help": "ユーザー名は一意であり、変更できません",
                "profile.email.readonly": "メールは変更できません",
                "profile.email.readonly.help": "メールは一意であるため変更できません",
                "profile.invitations.title": "招待状",
                "profile.invitations.validated": "検証された招待状",
                "profile.invitations.nextBadge": "次の成果",
                "profile.invitations.progress": "進捗",
                "profile.invitations.achievement": "成果",
                "profile.invitations.topInviterAchieved": "最大招待者に達しました",
                "profile.invitations.badges.networkBuilder": "ネットワークビルダー",
                "profile.invitations.badges.topInviter": "最大の招待者",
                "profile.invitations.achievement.networkBuilderMessage": "ArChat に 20 人のユーザーを招待しました。",
                "profile.invitations.achievement.topInviterMessage": "ArChat に 50 人のユーザーを招待しました。",
                "profile.plan.loading_info": "プラン情報を読み込んでいます...",
                "profile.plan.valid_until": "有効期限:",
                "profile.plan.active_since": "活動期間:",
                "profile.plan.active_badge": "✓ アクティブ",
                "profile.manage_plan": "計画を管理する",
                "plan.current_plan": "現在の計画",
                "plan.current": "Actual",
                'plan.footer_prefix': 'プラン：',
                "plan.upgrade_to_pro": "PRO にアップグレード",
                "plan.upgrade_to_foundation": "FOUNDATION にアップグレード",
                "plan.payment_coming": "Paddle での支払いも近日中に利用できるようになる予定です。こちらからプラン変更も可能です。",
                "plan.payment_coming_title": "すぐ",
                "plan.foundation_full": "FOUNDATION の定員は満員です (創設者 150 名)。 PROを選択できます。",
                "plan.sold_out": "疲れ果てた",
                "plan.founder_spots_remaining": "{count} か所のみ利用可能",
                "plan.founders_occupied": "多忙な創業者",
                "plan.upgrade_not_allowed": "無料プランのユーザーのみがアップグレードをリクエストできます。",
                "plan.free_contacts": "Hasta 2 contactos",
                "plan.free_no_files": "Sin archivos",
                "plan.free_retention": "Historial 30 días",
                "plan.pro_files": "Archivos hasta 50MB",
                "plan.pro_export": "Exportación",
                "plan.founder_support": "Prioridad soporte",
                "plan.founder_badge": "Badge fundador",
                "billing.usage.contacts": "連絡先",
                "billing.usage.chars_month": "月あたりの文字数",
                "billing.usage.storage": "使用済みストレージ",
                "billing.usage.devices": "接続されたデバイス",
                "billing.loading": "充電...",
                'billing.subscription.section_title': 'サブスクリプションと請求',
                'billing.subscription.provider_note': 'プロバイダー',
                'billing.subscription.paddle_active': 'Paddle（アプリ内で有効なプラン）',
                'billing.subscription.mp_action_ok': 'リクエストを記録しました。チェックアウトが開かない場合は接続を確認するか再試行してください。',
                'billing.paddle.manage_subscription_button': 'サブスクリプションを管理',
                'billing.paddle.portal_confirm_title': '請求ポータル',
                'billing.paddle.portal_confirm': '安全なPaddleポータルが開き、支払い方法・請求書の更新・サブスクリプションのキャンセルができます。続行しますか？',
                'billing.paddle.portal_opened_hint': 'Paddleポータルを新しいタブで開きました。プランが更新されない場合はプロフィールを更新してください。',
                'billing.paddle.portal_error': 'Paddleポータルを開けませんでした。後でもう一度試すかサポートに連絡してください。',
                'billing.paddle.no_link_error': 'アカウントにPaddleサブスクリプションのリンクがありません。支払い直後の場合はwebhookを待つかサポートに連絡してください。',
                'billing.paddle.api_not_configured': 'サーバーにPaddle API設定（PADDLE_API_KEY）がありません。管理者が設定する必要があります。',
                "billing.descriptions.contacts": "アカウントに保存されている連絡先の合計数",
                "billing.descriptions.storage": "ファイルとメディアに使用されるストレージ",
                "billing.descriptions.chars_month": "今月翻訳されたキャラクター",
                "billing.descriptions.devices": "アクティブな接続デバイス",
                'billing.paddle.return_title': 'お支払いを受け取りました',
                'billing.paddle.return_body': 'チェックアウトを完了した場合、Paddleの確認後にプランが更新されます。ホームに戻れます。',
                'billing.paddle.verifying': 'プランを確認しています…',
                'billing.paddle.not_logged_in': 'ログインしてプランの状態を確認してください。',
                'billing.paddle.plan_updated': 'プランを更新しました: {plan}',
                'billing.paddle.plan_current': '現在のプラン: {plan}',
                'billing.paddle.plan_current_founder': 'Founderになりました — {plan}',
                'billing.paddle.still_free_hint': 'しばらく待ってもFREEのままなら、webhookの遅延の可能性があります。バックエンドのログを確認するかページを更新してください。',
                'billing.paddle.pro_extra_hint': 'ホームに戻ってプランをご利用ください。',
                "attachment.audioNotSupported": "音声メッセージは ArChat® ではサポートされていません。書面によるメッセージをお送りください。",
                "message.audioDeprecated.title": "音声メッセージはサポートされていません",
                "message.audioDeprecated.message": "この音声メッセージは ArChat® ではサポートされなくなりました。書面によるメッセージをお送りください。",
                "profile.photo.select": "写真を選択",
                "profile.photo.select.gallery": "ギャラリーから選ぶ",
                "avatar.errors.too_large": "画像が大きすぎます。最大サイズ: 2 MB。",
                "avatar.preview.title": "アバターのプレビュー",
                "profile.avatar.error_title": "アバターを更新できませんでした",
                "profile.avatar.error.title": "アバターを更新できませんでした",
                "profile.avatar.error.size": "The image exceeds the allowed size.最大は 2 MB です。",
                "profile.avatar.tooLarge.title": "画像が大きすぎます",
                "profile.avatar.tooLarge.message": "写真が許容サイズを超えています。最大は 2 MB です。",
                "profile.avatar.uploadError.title": "アバターを更新できませんでした",
                "profile.avatar.uploadError.message": "画像のアップロード中に問題が発生しました。もう一度やり直してください。",
                "profile.saveSuccess.title": "プロフィールを更新しました",
                "profile.saveSuccess.message": "変更は正常に保存されました。",
                "profile.avatar.file_too_large": "画像が許容最大サイズ (2 MB) を超えています。",
                "profile.avatar.file_too_large_hint": "明るい画像を選択するか、サイズを小さくして、もう一度試してください。",
                "profile.photo.take.front": "フロントカメラ",
                "profile.photo.take.back": "リアカメラ",
                "profile.photo.take.webcam": "ウェブカメラ",
                "profile.photo.camera.front": "フロントカメラ",
                "profile.photo.camera.back": "リアカメラ",
                "profile.photo.camera.web": "ウェブカメラ",
                "profile.photo.close": "近い",
                "profile.photo.capture": "捕獲",
                "block.toggle_error": "ロックまたはロック解除ができませんでした。",
                "contact.favorite.add": "お気に入りに追加",
                "contact.favorite.remove": "お気に入りから削除",
                "contact.block.block": "ブロック",
                'contact.block.unblock': 'ブロック解除',
                "conversation.notFound": "会話が見つかりません",
                "help.howWorks.title": "👥 ArChat® の仕組み (実際の流れ)",
                "help.howWorks.step1.title": "1️⃣ 登録",
                "help.howWorks.step1.point1": "ニックネームとパスワードを使用してログインします。",
                "help.howWorks.step1.point2": "アカウントをお持ちでない場合は、自動的に作成されます。",
                "help.howWorks.step1.point3": "あなたの言語での利用規約に同意したことになります。",
                "help.howWorks.step1.point4": "電子メールでアカウントを確認します。",
                "help.howWorks.step2.title": "2️⃣ プライベート招待状",
                "help.howWorks.step2.point1": "プロフィールからメールで連絡先を招待します。",
                "help.howWorks.step2.point2": "開始する前に、言語と会話モードを定義します。",
                "help.howWorks.step2.point3": "連絡先はプライベート招待状を受け取ります。",
                "help.howWorks.step2.point4": "保留中、登録済み、チャット準備完了のいずれかを確認できます。",
                "help.howWorks.step2.point5": "連絡先は求められるものではなく、招待されるものです。",
                "help.howWorks.step2.point6": "連絡先は求められるものではなく、招待されるものです。",
                "help.howWorks.step3.title": "3️⃣ 連絡先と会話",
                "help.howWorks.step3.point1": "連絡先は次の場合に自動的に表示されます。",
                "help.howWorks.step3.point2": "招待を受け入れる",
                "help.howWorks.step3.point3": "または会話があります",
                "help.howWorks.step3.point4": "できる：",
                "help.howWorks.step3.point5": "お気に入りとしてマークしてください⭐",
                "help.howWorks.step3.point6": "カスタムエイリアスを割り当てる",
                "help.howWorks.step3.point7": "プライベートなメモを追加する",
                "help.howWorks.step3.point8": "ブロックするか管理する",
                "help.howWorks.step3.point9": "同意なしに公開議題やユーザーが表示されることはありません。",
                "help.howWorks.step4.title": "4️⃣ 翻訳付きメッセージング",
                "help.howWorks.step4.point1": "常にあなたの言語で書きましょう。",
                "help.howWorks.step4.point2": "システムはメッセージを自動的に翻訳します。",
                "help.howWorks.step4.point3": "受信者は自分の言語でそれを受け取ります。",
                "help.howWorks.step4.point4": "適用された翻訳を確認できます。",
                "help.howWorks.step4.point5": "変換が失敗した場合は、自動的に再試行されます。",
                "help.howWorks.step4.point6": "ArChat® は、スピードだけではなく、明確さと意味を優先します。",
                "help.privacy.title": "🔒 プライバシーとコントロール",
                "help.privacy.point1": "あなたのプロフィールはデフォルトでは非公開です。",
                "help.privacy.point2": "あなたが招待した人だけがあなたを閲覧したり、あなたに書き込んだりすることができます。",
                "help.privacy.point3": "一般公開はオプションであり、デフォルトでは無効になっています。",
                "help.privacy.point4": "以下を備えたアクティブセーフティ:",
                "help.privacy.point5": "キャプチャ",
                "help.privacy.point6": "レート制限",
                "help.privacy.point7": "指紋",
                "help.privacy.point8": "メール認証",
                "help.privacy.point9": "あなたの会話は公開されず、インデックスも作成されません。",
                "help.files.title": "📎 ファイルとエクスポート",
                "help.files.point1": "画像、ビデオ、PDF ドキュメントを添付します。",
                "help.files.point2": "フロントカメラ、リアカメラ、またはウェブカメラで写真を撮影します。",
                "help.files.point3": "画像は自動的に圧縮されます。",
                "help.files.point4": "送信する前にプレビューします。",
                "help.files.point5": "読み込み中の進行状況バー。",
                "help.files.point6": "会話全体を次の場所にエクスポートします。",
                "help.files.point7": "PDF",
                "help.files.point8": "HTML",
                "help.files.point9": "メッセージ、画像、ファイルが含まれます。",
                "help.files.point10": "あなたのデータはあなたのものです。",
                "help.experience.title": "🎨 ユーザーエクスペリエンス",
                "help.experience.point1": "絵文字を使用したプレゼンス ステータスとカスタム ステータス。",
                "help.experience.point2": "OpenMoji 絵文字を統合しました。",
                "help.experience.point3": "インジケーターの読み取りと書き込み。",
                "help.experience.point4": "デスクトップと同等に最適化されたモバイルビュー。",
                "help.experience.point5": "インストール可能なPWAアプリケーション。",
                "help.experience.point6": "テーマは 2 つ: アルゼンチン (ライトブルー/ホワイト/ゴールド) とオスクロ (ディープパープル)。",
                "help.experience.point7": "ソフトドリンクなしのプロフィール編集。",
                "help.experience.point8": "自動タイムゾーンを備えた国セレクター。",
                "help.experience.point9": "お気に入り、検索、フィルターを使用して素早くアクセスできます。",
                "help.languages.title": "🌍 言語",
                "help.languages.point1": "{count} 言語のサポート。",
                "help.languages.point2": "フラグ付きのビジュアルセレクター。",
                "help.languages.point3": "インターフェイス、利用規約、電子メールは選択した言語に適合します。",
                "help.languages.point4": "ユーザー間の双方向の自動翻訳。",
                "help.tipsNew.title": "💡 ArChat® を活用するためのヒント",
                "help.tipsNew.point1": "本当にコミュニケーションを取りたい人だけを招待してください。",
                "help.tipsNew.point2": "エイリアスと個人メモを使用して連絡先を整理します。",
                "help.tipsNew.point3": "すぐにアクセスできるようにお気に入りにマークを付けます。",
                "help.tipsNew.point4": "重要なメッセージを送信する前に翻訳を確認してください。",
                "help.tipsNew.point5": "バックアップまたは作業のために関連する会話をエクスポートします。",
                "help.tipsNew.point6": "文章の明瞭さが重要な場合は、ArChat® を使用してください。",
                "help.whySubscribe.title": "🚀 ArChat® に登録する理由",
                "help.whySubscribe.point1": "ArChat® は誰とでもチャットできるように設計されていません。",
                "help.whySubscribe.point2": "しかし、重要な人たちとより良いコミュニケーションをとるためです。",
                "help.whySubscribe.point3": "必要な場合:",
                "help.whySubscribe.point4": "言語間の明確さ",
                "help.whySubscribe.point5": "本当のプライバシー",
                "help.whySubscribe.point6": "コンタクトコントロール",
                "help.whySubscribe.point7": "会話のエクスポート",
                "help.whySubscribe.point8": "プロフェッショナルでノイズのない体験",
                "help.whySubscribe.point9": "ArChat® はそのために設計されています。",
                "help.message_time_context.title": "メッセージの時間的コンテキスト",
                "help.message_time_context.description": "各メッセージは、送信時の送信者の現地時間、タイムゾーン、および国を保存できます。こうすることで、他のユーザーがいつ、どこに送信したかを確認できます。",
                "help.message_time_context.point1": "FREEプランでは、お使いのタイムゾーン（受信機）の時刻のみが表示されます。",
                "help.message_time_context.point2": "PRO プランでは、発行者の現地時間、国、タイムゾーンも表示されます。",
                "help.message_time_context.point3": "コンテキストは各メッセージに履歴として保存されます。",
                "help.message_time_context.point4": "高度な監査機能は上位プランで利用できます。",
                "help.tips.writing": "✅ 明確なメッセージを書く: ArChat® は、文脈と明確さを維持しながら、書かれたテキストの意味を翻訳します。",
                'presence.custom.title': 'Kasutamu suteetasu',
                'presence.custom.status': 'Kasutamu suteetasu',
                'presence.custom.placeholder': 'Rei: Koohii chuu ☕',
                'presence.custom.emoji': 'Emoji (nin-i)',
                'presence.custom.emojiHelp': 'Emoji o sentaku suru ka nyuryoku shite kudasai',
                'presence.custom.temporary': 'Ichiji suteetasu (jidouteki ni kigen ga kireru)',
                'presence.custom.expiration': 'Shiyou kigen',
                'presence.custom.expirationHelp': 'Kigen ga kiretara suteetasu wa "Online" ni modorimasu',
                'presence.custom.suggestions': 'Sajeshon',
                'presence.custom.preview': 'Purezento',
                'presence.custom.save': 'Suteetasu o hozon',
                'presence.custom.required': 'Kasutamu suteetasu wa hitsuyou desu',
                'presence.custom.maxLength': 'Saidai 64 moji',
                'presence.custom.expirationRequired': 'Shiyou kigen no sentaku ga hitsuyou desu',
                'presence.custom.expirationFuture': 'Shiyou kigen wa mirai no jikan de aru hitsuyou ga arimasu',
                'presence.custom.selectEmoji': 'Emoji o sentaku',
                "invitation.success.title": "招待状を送信しました",
                "invitation.success.message": "招待状は正常に送信されました。\\n\\n連絡先には、招待状を受け入れるためのリンクが記載されたメールが届きます。承認されると、彼とのチャットを開始できます。",
                "invitation.top.title": "トップネットワークビルダー",
                "invitation.top.invitesSuffix": "招待状",
                "invitation.ranking.position": "位置",
                "invitation.ranking.user": "ユーザー",
                "invitation.ranking.validatedInvites": "検証された招待状",
                "invitation.ranking.empty": "表示できる検証済みの招待状はありません。",
                "invitation.ranking.loading": "ランキングを読み込んでいます...",
                "invitation.ranking.loadError": "ランキングを読み込めませんでした。",
                "invitations.waitBeforeResend": "まだ招待状を再送信することはできません。ゲスト ユーザーへのスパム送信を避けるために、送信ごとに 10 分間待つ必要があります。",
                "invitations.captchaQuestion": "%1 + %2 はいくらですか?",
                "invitations.resendSuccess": "招待状は正常に転送されました。",
                "invitations.dailyLimit": "本日、再送信が許可される最大数に達しました。",
                "invitations.invalidEmail": "メール サーバーは、このアドレスが無効であると報告しました。",
                "achievement.unlocked": "実績のロックが解除されました",
                "achievement.continue": "続く",
                'dashboard.not_available': '利用できません',
                "plan.errors.chatsLimit.title": "会話制限に達しました",
                "plan.errors.chatsLimit.message": "現在のプランでは、会話できる数に制限があります。",
                "plan.errors.chatsLimit.solution": "さらに多くの会話を作成するには、プランを PRO にアップグレードしてください。",
                "errors.generic": "予期しないエラーが発生しました。もう一度やり直してください。",
                "errors.modal.title": "間違い",
                "errors.modal.copyDetails": "詳細をコピーする",
                "errors.modal.close": "近い",
                "errors.modal.reportSupport": "サポートに報告する",
                "errors.avatarTooLarge": "画像が許容サイズの 2MB を超えています。",
                "errors.avatarTooLarge.title": "画像が大きすぎます",
                "errors.avatarTooLarge.message": "画像が許容サイズの 2MB を超えています。",
                "errors.invalidImageType": "選択したファイルは有効な画像ではありません。",
                "errors.invalidImageType.title": "無効なファイル",
                "errors.invalidImageType.message": "選択したファイルは有効な画像ではありません。",
                "errors.uploadFailed": "画像をアップロードできませんでした。もう一度やり直してください。",
                "errors.uploadFailed.title": "アップロードエラー",
                "errors.uploadFailed.message": "画像をアップロードできませんでした。もう一度やり直してください。",
                "errors.conversationCreate": "会話の作成中にエラーが発生しました。もう一度試してください。",
                "errors.conversationInvalidId": "会話 ID が無効です。",
                "errors.conversationOpen": "会話を開くときにエラーが発生しました。もう一度試してください。",
                "errors.favoriteUpdate": "お気に入りの更新に失敗しました",
                "errors.blockUpdate": "ロックを更新できませんでした",
                "errors.messageEdit": "メッセージの編集中にエラーが発生しました。",
                "errors.foundation_sold_out": "ファウンダースポットは完売しました。",
                "errors.unexpected_error": "予期しないエラーが発生しました。もう一度やり直してください。",
                "errors.userInactive.title": "無効化されたアカウント",
                "errors.tenantMismatch.title": "テナントエラー",
                'auth.tagline': '言語に関係なく理解される力',
                'auth.sign_in': 'ログイン',
                'auth.create_account': 'アカウント作成',
                'ui.search_contact': '連絡先を検索...',
                'ui.language': '言語',
                'profile.my_profile': 'マイプロフィール',
                'profile.status': 'ステータス',
                'profile.invite_email': 'メールで連絡先を招待',
                'profile.sent_invitations': '送信した招待',
                "profile.users": "ユーザー",
                'profile.settings': '設定',
                'profile.appearance': '外観',
                'profile.logout': 'ログアウト',
                'contacts.mode': 'モード',
                'contacts.sent': '送信',
                'contacts.actions': 'アクション',
                'contacts.pending': '保留中',
                'contacts.available': '利用可能',
                'contacts.invited_registered': '招待済み - 登録済み',
                'table.email': 'メール',
                'table.language': '言語',
                'table.mode': 'モード',
                'table.status': '状態',
                'table.sent': '送信日時',
                'table.actions': '操作',
  'promotions.invite.message': 'ArChat にご招待します。どの言語でも話せます。私たちは両方とも利益を得ることができます。',
  'promotions.progress.pending': '特典のロックを解除するための保留中の招待状があります。',
  'promotions.progress.in_progress': '招待が進行中です。実際の会話後に特典が有効になります。',
  'promotions.progress.remaining': '報酬を受け取るにはあと {count} 回会話する必要があります。',
  'promotions.progress.sent_count': '送信済み',
  'promotions.progress.pending_count': '保留中',
  'promotions.progress.in_progress_count': '進行中',
  'promotions.progress.completed_count': '完了しました',
  'promotions.banner.empty': '今すぐ始めましょう: 連絡先を招待して特典を利用しましょう。',
  'promotions.banner.pending': '保留中の招待状があります。実際の会話を完了して報酬を獲得してください。',
  'promotions.banner.reward': 'すでに報酬をアンロックしています!利益を増やすために招待し続けてください。',
  'promotions.cta.copy': 'メッセージとリンクをコピーする',
  'promotions.cta.copied': 'メッセージがコピーされました',
  'promotions.cta.copy_error': 'メッセージをコピーできませんでした',

  'promotions.title': 'プロモーションと特典',
  'promotions.subtitle': '連絡先を招待し、実際の使用を通じてメリットを解放します。',
  'promotions.how_it_works': '仕組み',
  'promotions.step1': 'プロフィールから連絡先を招待します。',
  'promotions.step2': '実際のやり取りを受け入れてチャットすると、自動的に検証されます。',
  'promotions.step3': '報酬がクレジットされ、進捗状況が更新されます。',
  'promotions.rewards.title': '報酬',
  'promotions.reward.invite': '検証された紹介ごとに報酬が与えられます。',
  'promotions.reward.milestone': '成長マイルストーンに対するボーナス。',
  'promotions.reward.ranking': '上位のネットワーク ビルダー ランキングでの可視性。',
  'promotions.progress.title': 'あなたの進歩',
  'promotions.progress.sent': '送信済み',
  'promotions.cta.invite': '連絡先を招待',
  'promotions.banner': 'プロモーションを有効にする: 招待して、実際の使用に対して報酬を獲得します。',
  'promotions.modal.title': 'プロモーションプログラム',
  'promotions.modal.body': '検証された招待ごとに +10.000 キャラクターを獲得できます。\\\\n今すぐ招待して報酬を獲得しましょう。',
  'promotions.modal.cta': 'プロモーションを見る',
                "app.install_ios_hint": "インストールするには: [共有] > [ホーム画面に追加]",
                'menu.promotions': 'プロモーション',
                "suggestions.new": "新しい提案",
                "suggestions.empty": "まだ提案は提出されていません。",
                "suggestions.admin_note": "チームメモ",
                "suggestions.status.pending": "イヤリング",
                "suggestions.status.reviewed": "改訂",
                "suggestions.status.planned": "計画済み",
                "suggestions.status.implemented": "実装済み",
                "suggestions.status.rejected": "拒否されました",
                "referral.promo": "10,000 キャラクターを招待して獲得しましょう",
                "referral.stats.sent": "送信済み",
                "referral.stats.accepted": "承認されました",
                "referral.stats.rewards": "報酬",
                "referral.reward.pending": "イヤリング",
                "referral.reward.granted": "満たされた",
                "referral.reward.invalid": "無効",
                "referral.reward.in_progress": "使用中",
                "referral.limit.reached": "報酬上限に達しました",
                "referral.waiting.usage": "あなたとゲストが同じチャットで少なくとも 1 つの実際のテキスト メッセージを送信する場合、それぞれ +10,000 文字 (サーバー検証済み)。",
                "common.avatar": "アバター",
                "plan.free_characters_month": "30,000 characters / month",
                "plan.pro_characters_month": "300,000 characters / month",
                "messages.empty": "まだメッセージはありません",
                "messages.loading": "メッセージを読み込んでいます...",
                "messages.connecting_server": "メッセージサーバーに接続しています...",
                "messages.pending_send_count": "{count} 件のメッセージが配信を待機しています",
                "presence.custom.suggestion.coffee": "仲間がいる☕",
                "presence.custom.suggestion.soccer": "コート上⚽",
                "presence.custom.suggestion.working": "狂ったように働いています 💪",
                "presence.custom.suggestion.lunch": "ランチ🍽️",
                "presence.custom.suggestion.family": "家族ランチ👨‍👩‍👧‍👦",
                "presence.custom.suggestion.studying": "勉強中📚",
                "presence.custom.suggestion.travel": "旅行中✈️",
                "presence.custom.suggestion.meeting": "打ち合わせ中💼",
                "presence.custom.suggestion.resting": "休憩中😴",
                "presence.custom.suggestion.gaming": "ビデオゲームをする 🎮",
                "presence.custom.suggestion.reading": "読書 📖",
                "presence.custom.suggestion.offlineSoon": "すぐに戻ってきます⏳",
                "invitation.safe.phase_notice": "アクティブ セーフ フェーズ: 商用アクティベーションが保留中の特典 (制限に対する実際の影響はありません)。",
                "invitation.safe.generate_code": "リンク/コードを生成する",
                "invitation.safe.refresh_top3": "トップ3を更新",
                "invitation.safe.top_loading": "上位の招待者を読み込み中...",
                "invitation.safe.top_empty": "注目の招待者はまだいません。",
                "invitation.safe.hide_full_ranking": "完全なランキングを非表示にする",
                "invitation.safe.view_full_ranking": "ランキング全体を見る",
                "invitation.safe.hide_metrics_dashboard": "メトリクスダッシュボードを非表示にする",
                "invitation.safe.view_metrics_dashboard": "メトリクスダッシュボードを表示する",
                "invitation.safe.prepared_link": "リンクが準備されました",
                "invitation.safe.email_placeholder": "email@dominio.com",
                "invitation.safe.register_pending": "保留中の招待状を登録する",
                "invitation.safe.status_summary": "ステータスの概要",
                "invitation.safe.summary.pending": "イヤリング",
                "invitation.safe.summary.registered": "登録済み",
                "invitation.safe.summary.active": "アクティブ",
                "invitation.safe.summary.validated": "検証済み",
                "invitation.safe.summary.rejected": "拒否されました",
                "invitation.safe.sent_invitations": "招待状の発行",
                "invitation.safe.table.id": "ID",
                "invitation.safe.table.invited_email": "ゲストメールアドレス",
                "invitation.safe.table.code": "コード",
                "invitation.safe.table.status": "州",
                "invitation.safe.table.created": "作成されました",
                "invitation.safe.empty_sent": "まだ招待状は発行されていません。",
                "invitation.safe.simulated_rewards": "シミュレートされた報酬の獲得",
                "invitation.safe.empty_rewards": "今のところ模擬報酬はありません。",
                "invitation.safe.error.load_status": "招待ステータスを読み込めませんでした。",
                "invitation.safe.error.generate_code": "コードを生成できませんでした。",
                "invitation.safe.error.invalid_email": "有効な電子メールを入力して招待を登録します。",
                "invitation.safe.error.register_pending": "保留中の招待状を登録できませんでした。",
                "invitation.safe.success.code_generated": "コードが正常に生成されました。",
                "invitation.safe.success.pending_registered": "セーフ モードで登録された保留中の招待。",
                "invitation.status.deleted": "排除された",
                "invitation.deleted.tooltip": "この招待状は削除されました",
                "invitation.status.rejected": "拒否されました",
                "invitation.status.bounced": "跳ね返った",
                "invitation.status.unknown": "不明なステータス",
                "dashboard.admin.title": "成長指標",
                "dashboard.admin.newUsersToday": "今日の新規ユーザー",
                "dashboard.admin.messagesSentToday": "今日送信されたメッセージ",
                "dashboard.admin.translationsUsed": "使用された翻訳",
                "dashboard.admin.invitesCreated": "招待状が作成されました",
                "dashboard.admin.invitesValidated": "検証された招待状",
                "dashboard.admin.inviteConversion": "招待状の変換",
                "dashboard.admin.kFactor": "K-ファクター",
                "dashboard.admin.newUsers": "新規ユーザー",
                "dashboard.admin.messagesSent": "送信済みメッセージ",
                "dashboard.admin.noData": "データなし",
                "dashboard.admin.kFactor.viral": "バイラル",
                "dashboard.admin.kFactor.stable": "安定した",
                "dashboard.admin.kFactor.low": "低い",
                "dashboard.admin.emailMetrics": "電子メール指標",
                "dashboard.admin.email.sent": "送信済み",
                "dashboard.admin.email.delivered": "納品済み",
                "dashboard.admin.email.opened": "開ける",
                "dashboard.admin.email.clicked": "クリック数",
                "dashboard.admin.email.bounced": "跳ね返った",
                "dashboard.admin.email.deliveryRate": "配送率",
                "dashboard.admin.email.openRate": "開封率",
                "dashboard.admin.email.bounceRate": "直帰率",
                "dashboard.admin.funnelMetrics": "ファネル指標",
                "dashboard.admin.funnel.registered": "登録済み",
                "dashboard.admin.funnel.confirmed": "確認済み",
                "dashboard.admin.funnel.loggedIn": "初回ログイン",
                "dashboard.admin.funnel.firstMessage": "最初のメッセージ",
                "dashboard.admin.funnel.abandoned": "放棄された",
                "dashboard.admin.funnel.conversionRate": "コンバージョン率",
                "dashboard.admin.funnel.activationRate": "活性化率",
                "dashboard.admin.funnel.dropoffRate": "中退率",
                "dashboard.admin.loading": "指標を読み込み中...",
                "dashboard.admin.errorLoad": "メトリクス ダッシュボードを読み込めませんでした。",
                "dashboard.admin.growthViral": "ウイルスの増殖",
                "dashboard.admin.growthStable": "安定成長",
                "dashboard.admin.growthLow": "低成長",
                'upgrade.price.amount': '',
                'upgrade.price.period': '',
                "upgrade.enterprise.title": "ENTERPRISE",
                "errors.modal.code": "コード",
                "errors.modal.message": "メッセージ",
                "errors.modal.path": "ルート",
                "errors.modal.time": "時間",
                "errors.modal.timestamp": "タイムスタンプ",
                "errors.modal.copied": "コピーされた詳細",
                "errors.network": "サーバーに接続できませんでした。接続を確認してください。",
                "errors.unexpected": "予期しないエラーが発生しました。もう一度やり直してください。",
                "errors.boundary.title": "反応エラーがキャプチャされました",
                "errors.boundary.request_id": "XリクエストID:",
                "errors.boundary.correlate": "backend/logs/structured.log にマップします。",
                "errors.boundary.message_label": "メッセージ：",
                "errors.boundary.stack_trace": "スタックトレース",
                "errors.boundary.component_stack": "コンポーネントスタック",
                "errors.boundary.empty": "（空の）",
                "errors.boundary.reload_page": "ページをリロードする",
                "errors.ui_boundary.refresh": "ArChat インターフェース エラー - ページのリロード",
                "bootstrap.error.title": "ArChat® — ブート エラー",
                "common.reload": "リチャージ",
                "admin.access_denied.message": "メッセージ",
                "admin.access_denied.title": "タイトル",
                "admin.action.change_plan": "計画変更",
                "admin.action.reactivate": "再アクティブ化",
                "admin.action.suspend": "つるす",
                "admin.action.view": "ビュー",
                "admin.confirm.change_plan.message": "メッセージ",
                "admin.confirm.change_plan.title": "タイトル",
                "admin.confirm.suspend.message": "メッセージ",
                "admin.confirm.suspend.title": "タイトル",
                "admin.details.created": "作成されました",
                "admin.details.current_plan": "現在の計画",
                "admin.details.domain": "ドメイン",
                "admin.details.last_activity": "最後のアクティビティ",
                "admin.details.name": "ヤムイモ",
                "admin.details.plan": "プラン",
                "admin.details.status": "状態",
                "admin.details.subscription": "サブスクリプション",
                "admin.details.tenant_id": "テナントID",
                "admin.details.tenant_info": "テナント情報",
                "admin.details.usage": "使用法",
                "admin.error.change_plan": "計画変更",
                "admin.error.generic": "ジェネリック",
                "admin.error.load_details": "詳細をロードする",
                "admin.error.load_tenants": "テナントのロード",
                "admin.error.reactivate": "再アクティブ化",
                "admin.error.suspend": "つるす",
                "admin.error.title": "タイトル",
                "admin.filter.active": "活性化",
                "admin.filter.all_plans": "すべてのプラン",
                "admin.filter.all_status": "すべてのステータス",
                "admin.filter.suspended": "つるす",
                "admin.limit.devices": "デバイス",
                "admin.limit.invitations": "招待状",
                "admin.limit.messages": "メッセージ",
                "admin.limit.storage": "ストレージ",
                "admin.limit.users": "ユーザー",
                "admin.loading": "読み込み中",
                "admin.no_tenants": "非テナント",
                "admin.plan.enterprise": "Enterprise",
                "admin.plan.free": "Free",
                "admin.plan.pro": "Pro",
                "admin.status.active": "活性化",
                "admin.status.suspended": "つるす",
                'admin.subscription.id': 'Id',
                "admin.subscription.last_payment": "最後の支払い",
                "admin.subscription.status": "状態",
                "admin.subtitle": "字幕",
                "admin.success.plan_changed": "計画が変更されました",
                "admin.success.tenant_reactivated": "テナントが再アクティブ化されました",
                "admin.success.tenant_suspended": "テナントの一時停止",
                "admin.success.title": "タイトル",
                "admin.table.actions": "アクション",
                "admin.table.messages": "メッセージ",
                "admin.table.name": "ヤムイモ",
                "admin.table.plan": "プラン",
                "admin.table.status": "状態",
                "admin.table.storage": "ストレージ",
                "admin.table.tenant_id": "テナントID",
                "admin.table.users": "ユーザー",
                "admin.title": "タイトル",
                "admin.usage.devices": "デバイス",
                "admin.usage.invitations": "招待状",
                "admin.usage.messages": "メッセージ",
                "admin.usage.storage": "ストレージ",
                "admin.usage.users": "ユーザー",
                "auth.login": "ログイン",
                "auth.register": "登録する",
                "auth.reset_password": "パスワードをリセットする",
                "billing.cancel.button": "ボタン",
                "billing.cancel.canceling": "キャンセルする",
                "billing.cancel.confirm": "確認する",
                "billing.cancel.error": "間違い",
                "billing.cancel.success": "成功",
                "billing.character_billing.characters_used": "使用キャラクター",
                "billing.character_billing.consumption_pct": "消費率",
                "billing.character_billing.days_remaining": "残り日数",
                "billing.character_billing.deletion_date": "削除日",
                "billing.character_billing.period_start": "期間開始",
                "billing.character_billing.renewal_date": "更新日",
                "billing.character_billing.title": "タイトル",
                "billing.current_plan": "現在の計画",
                "billing.founder_badge": "創設者バッジ",
                "billing.no_plans": "計画しないでください",
                'billing.subscription.canceled': 'Canceled',
                'billing.subscription.canceled_note': 'Canceled note',
                "billing.subscription.next_payment": "次回のお支払い",
                "billing.subscription.plan": "プラン",
                'billing.subscription.price': 'プラン料金',
                "billing.subscription.started": "開始しました",
                "billing.subscription.status": "状態",
                "billing.subscription.mp_flow.subscribe_failed": "サブスクリプションを開始できませんでした。もう一度やり直してください。",
                "billing.subscription.mp_flow.change_plan_failed": "計画は変更できなかった。もう一度やり直してください。",
                "billing.subscription.mp_status.pending": "イヤリング",
                "billing.subscription.mp_status.authorized": "認可された",
                "billing.subscription.mp_status.active": "アクティブ",
                "billing.subscription.mp_status.paused": "一時停止中",
                "billing.subscription.mp_status.cancelled": "キャンセル",
                "billing.subscription.mp_status.inactive": "非アクティブ",
                "billing.subscription.mp_status.unknown": "見知らぬ人",
                "billing.unlimited": "無制限",
                "billing.update_plan": "計画を更新する",
                "billing.update_plan_modal.title": "タイトル",
                "billing.usage.loading": "読み込み中",
                "common.accept": "受け入れる",
                "common.confirmPassword": "パスワードを認証する",
                'common.continue': '続行',
                "common.error": "間違い",
                "dashboard.upgrade.to_plan": "計画を立てる",
                "emoji.noResults": "結果なし",
                "emoji.pick": "選ぶ",
                "export.restricted.message": "メッセージ",
                "export.restricted.title": "タイトル",
                "export.restricted.upgrade": "アップグレード",
                "founder.*": "*",
                "help.faq.a1": "A1",
                "help.faq.a2": "A2",
                "help.faq.a3": "A3",
                "help.faq.a4": "A4",
                "help.faq.a5": "A5",
                "help.faq.a6": "A6",
                "help.faq.a7": "A7",
                "help.faq.q1": "Q1",
                "help.faq.q2": "第2四半期",
                "help.faq.q3": "Q3",
                "help.faq.q4": "Q4",
                "help.faq.q5": "Q5",
                "help.faq.q6": "Q6",
                "help.faq.q7": "Q7",
                "help.faq.title": "タイトル",
                "help.howWorks.step4.point7": "ポイント7",
                "help.message_time_context.free_vs_pro": "無料対プロ",
                "help.message_time_context.point5": "Point5",
                "help.plans.enterprise.benefits": "利点",
                "help.plans.enterprise.description": "説明",
                "help.plans.enterprise.title": "タイトル",
                "help.plans.foundation.devices": "デバイス",
                "help.plans.free.description": "説明",
                "help.plans.free.devices": "デバイス",
                "help.plans.free.limits": "限界",
                "help.plans.free.title": "タイトル",
                "help.plans.intro": "イントロ",
                "help.plans.pro.benefits": "利点",
                "help.plans.pro.description": "説明",
                "help.plans.pro.devices": "デバイス",
                'help.plans.pro.price': '$19 /月',
                "help.plans.pro.title": "タイトル",
                "help.plans.pro.upgrade": "アップグレード",
                "help.plans.title": "タイトル",
                "help.plans.urgent_slots_badge": "緊急スロットバッジ",
                "help.slogan.final": "終わり",
                "help.suggestions.point1": "ポイント1",
                "help.suggestions.point2": "ポイント2",
                "help.suggestions.title": "タイトル",
                "invitation.already_contact_added": "すでに連絡先が追加されています",
                "invitation.already_contact_title": "すでに連絡済み タイトル",
                "invitation.already_pending": "すでに保留中",
                "invitation.language.invalid": "無効",
                "message.send": "送信",
                "message.sendFile": "ファイルの送信",
                "messages.conversations": "会話",
                "messages.no_conversations_subtitle": "会話字幕なし",
                "messages.no_conversations_title": "会話のタイトルはありません",
                "presence.custom.edit": "編集",
                "profile.enrichment.country": "国",
                "profile.enrichment.country.select": "選択",
                "profile.enrichment.description": "説明",
                "profile.enrichment.org_size": "組織の規模",
                "profile.enrichment.org_size.placeholder": "プレースホルダー",
                "profile.enrichment.save": "保存",
                "profile.enrichment.skip": "スキップ",
                "profile.enrichment.title": "タイトル",
                "profile.enrichment.usage_type.label": "ラベル",
                "profile.enrichment.usage_type.placeholder": "プレースホルダー",
                "profile.founderPosition": "創設者の役職",
                "settings.confirmations.description": "説明",
                "settings.confirmations.disable": "無効にする",
                "settings.confirmations.title": "タイトル",
                "settings.confirmations.updated": "更新されました",
                "settings.title": "タイトル",
                "theme.description": "説明",
                "google.unavailable_tenant": "このテナントでは Google を利用できません。",
                "google.unavailable": "Googleは利用できません。",
                "google.verify_client_id": "Google Cloud Console でクライアント ID を確認します。",
                'google.login_aria': 'Googleでログイン',
                "message.preview_alt": "プレビュー",
                "message.image_attachment_alt": "添付画像",
                "profile.avatar.alt": "アバター",
                "plan.name.free": "FREE",
                "plan.name.pro": "PRO",
                "plan.name.foundation": "FOUNDATION",
                "plan.name.enterprise": "ENTERPRISE",
                "register.emailPlaceholder": "you@email.com",
                "invitation.top.loading": "上位の招待者を読み込み中...",
                "invitation.top.empty": "注目の招待者はまだいません。",
                "invitation.contacts.title": "連絡先を招待する",
                "invitation.contacts.safe_phase_note": "安全フェーズがアクティブ: 実際の制限に影響を与えずに保留中の特典。",
                "invitation.contacts.generate_code": "コード/リンクを生成する",
                "invitation.contacts.refresh_top3": "トップ 3 を更新",
                "invitation.contacts.hide_full_ranking": "完全なランキングを非表示にする",
                "invitation.contacts.show_full_ranking": "完全なランキングを表示",
                "invitation.contacts.hide_metrics_dashboard": "メトリクスダッシュボードを非表示にする",
                "invitation.contacts.show_metrics_dashboard": "メトリクスダッシュボードを表示",
                "invitation.contacts.prepared_link_label": "準備されたリンク:",
                "invitation.contacts.email_placeholder": "email@domain.com",
                "invitation.contacts.register_pending": "保留中の招待状を登録する",
                "invitation.contacts.status_summary": "ステータスの概要",
                "invitation.contacts.sent_invitations": "送信された招待状",
                "invitation.contacts.invited_email": "招待メール",
                "invitation.contacts.code": "コード",
                "invitation.contacts.no_sent_invitations": "まだ招待状を送っていません。",
                "invitation.contacts.simulated_rewards": "模擬報酬の獲得",
                "invitation.contacts.no_simulated_rewards": "模擬報酬はまだありません。",
                "common.id": "ID",
                "common.created": "作成されました",
                'plan.pro_contacts': 'ユーザーあたり最大100件の連絡先',
                "common.status": "状態",
                "login.prompt_create_account_with_name": "この名前でアカウントを作成しますか?",
                'plans.upgrade.title': 'プランをアップグレード',
                'plans.upgrade.comparison': 'プラン比較',
                'plans.upgrade.billing': '',
                'plans.upgrade.cancel_anytime': 'いつでも解約可能',
                'plans.actions.upgrade_pro': 'PROにアップグレード',
                'plans.actions.become_founder': 'Founderになる',

                'plans.modal.card.current_badge': '現在のプラン',

                'plans.modal.card.lower_tier': '有効プランより下の段階',

                'plans.modal.card.manage_in_profile': '変更や解約は、プロフィールの「購読と請求」から。',
                'plans.modal.card.cancel_subscription': 'サブスクリプションをキャンセル',
                'plans.modal.cancel_confirm.title': '購読のキャンセルまたは管理',
                'plans.modal.cancel_confirm.body': '新しいタブで安全なPaddleのポータルが開き、支払い方法・請求書の確認や購読の解約ができます。',
                'plans.modal.cancel_confirm.continue_button': '続行',
                'plans.modal.cancel_confirm.back_button': '戻る',
                'plans.modal.cancel_paddle_fallback.title': 'サブスクリプションの管理',
                'plans.modal.cancel_paddle_fallback.body': 'この環境ではPaddleの請求ポータルは開きません（ローカル開発や未連携など）。この画面でプランの確認・比較は引き続きできます。',
                'plans.modal.cancel_paddle_fallback.confirm': '了解',
                'plans.upgrade_required': 'PROプランで利用可能',
                'settings.heading': '設定',
                'settings.dashboard': 'ダッシュボード',
                'settings.dashboardDescription': 'ホームパネルと表示ブロックのローカル設定です。',
                'settings.dashboardGridHeading': 'パネルブロック',
                'settings.dashboardShowOnStartDescription': 'オンの場合、サインイン後にダッシュボードを開き、連絡先一覧の代わりにします。',
                'settings.dashboardBlockWelcome': 'ウェルカム',
                'settings.dashboardBlockUsage': 'プラン使用量',
                'settings.dashboardBlockFiles': 'マイファイル',
                'settings.dashboardBlockPromotions': 'プロモ',
                'settings.dashboardBlockSessions': 'セッション',
                'settings.dashboardWelcomeDescription': 'はじめの一歩、招待、ヘルプへのショートカット。',
                'settings.dashboardUsageDescription': '上限との比較: 連絡先、文字、ストレージ、端末。',
                'settings.dashboardFilesDescription': '「マイファイル」の表示ファイルと容量の要約。',
                'settings.dashboardPromotionsDescription': 'プロモの概要とプログラムへのリンク。',
                'settings.dashboardSessionsDescription': 'アクティブなセッションと端末。他セッションを終了できる場合は表示。',
                'settings.enabled': 'オン',
                'settings.disabled': 'オフ',
                'settings.showDashboardOnStart': 'ログイン後に表示',
                'settings.showWelcomeBlock': 'ウェルカム欄',
                'settings.showPromotionsBlock': 'プロモーション欄',
                'settings.showUsageBlock': '利用状況欄',
                'settings.showRecentConversationsBlock': '最近の会話を表示（連絡先ごとの最新メッセージ）',
                'settings.showSessionsBlock': 'セッション欄',
                'settings.showFilesBlock': 'ファイル要約欄',
                'settings.dashboardLocalNote': 'プロフィールAPIができるまで、設定はこのブラウザに保存されます。',
                'settings.appearanceSettings': '外観',
                'settings.argentinaTheme': 'アルゼンチンテーマ',
                'settings.darkMode': 'ダークモード',
                'settings.language': '言語',
                'settings.messageSound': 'メッセージ音',
                'settings.playSoundDescription': '新しいメッセージや重要な通知で音を再生します。',
                'settings.messageSoundEnabled': 'オン',
                'settings.messageSoundDisabled': 'オフ',
                'settings.accountSettings': 'アカウント',
                'settings.deleteAccount': 'アカウントを削除',
                'settings.deleteAccountWarning': 'これは永久です。データ、メッセージ、連絡先、設定はプラットフォームの削除手順に従って削除されます。',
                'settings.deleteMyAccount': 'マイアカウントを削除',
                'dashboard.contacts': '連絡先',
                'dashboard.characters': '文字数',
                'dashboard.storage': 'ストレージ',
                'dashboard.active_devices': 'アクティブなデバイス',
                'dashboard.need_more_resources': 'さらにリソースが必要ですか？',
                'dashboard.upgrade_message': '連絡先、文字数、ストレージ、アクティブなデバイスを増やすには、プランをアップグレードしてください。',
                'dashboard.upgrade_button': 'PROにアップグレード',
                'dashboard.upgrade_button_pro': 'PROにアップグレード',
                'dashboard.upgrade_button_foundation': 'FOUNDATIONにアップグレード',
                'files.preview': 'プレビュー',
                'files.previewFile': 'ファイルのプレビュー',
                'files.previewUnavailable': 'プレビューできません。',
                'files.previewLoading': 'プレビューを読み込み中…',
                'files.openPreview': 'プレビュー',
                'files.downloadFile': 'ファイルをダウンロード',
                'files.downloadFailed': 'ファイルをダウンロードできませんでした。接続とセッションを確認して、もう一度お試しください。',
                'files.closePreview': 'プレビューを閉じる',
                'files.unsupportedPreview': 'この種類のファイルはプレビューできません。情報を表示するかダウンロードできます。',
                'files.pdfPreviewHelp': 'ブラウザーに埋め込みPDFが表示されない場合があります。開くにはダウンロードを使用します。',
                'files.labelFileType': '種類',
                'files.previewForbidden': 'プレビューの権限がありません。',
                'files.previewNotFound': 'ファイルを利用できないか、アカウントに表示されません。',
                'files.unavailableForFree': '「マイファイル」は FREE プランでは利用できません。',
                'files.availableInFoundationAndPro': '「マイファイル」は FOUNDATION および PRO で利用できます。',
                'files.filesFeatureRestricted': 'お使いのプランではこの機能は利用できません。',
                'files.filesLoadError': 'ファイルの読み込みエラーです。',
                'files.uploadUnavailableForFree': 'FREEプランではファイル送信は利用できません。',
                'files.uploadAvailableInFoundationAndPro': 'ファイル送信はFOUNDATIONとPROで利用できます。',
                'files.recipientStorageFull': '相手にこのファイルを受け取る空き容量がありません。',
                'files.recipientNoAvailableStorage': '相手にこのファイルを受け取る空き容量がありません。',
                'files.storageQuotaExceeded': 'プランのストレージ上限に達しました。',
                'files.freeStorageLimit': 'FREEプランには受信ファイル用に5MBが含まれます。',
                'settings.unreadEmailReminderSection': '未読サマリーのメール',
                'settings.unreadEmailReminderDescription': '新しいメッセージやファイルが下記の時間より長く未読のとき、ArChatはまとめた1通のメールを送ります（1件ごとではありません）。',
                'settings.unreadEmailReminderToggle': '未読サマリーをメールで受け取る',
                'settings.unreadEmailDelayHours': '送信までの待ち時間（時間）',
                'settings.unreadEmailDelayHint': '1〜168時間（最大1週間）。メールの言語はプロフィールに従います。',
                'subjects.title': '件名',
                'subjects.singular': '件名',
                'subjects.plural': '件名',
                'subjects.general': '一般',
                'subjects.new': '新しい件名',
                'subjects.create': '件名を作成',
                'subjects.rename': '名前を変更',
                'subjects.finish': '完了',
                'subjects.reopen': '再開',
                'subjects.select': '続行',
                'subjects.status.open': 'オープン',
                'subjects.status.pending': '保留',
                'subjects.status.finished': '完了済み',
                'subjects.limitReached': 'この会話で有効な件名の上限に達しました。件名を終了してから新規作成してください。',
                'subjects.limitReachedFree': 'FREEプランは会話ごとに最大3件の有効な件名です。件名を終了してから新規作成してください。',
                'subjects.limitReachedPro': 'PROプランは会話ごとに最大5件の有効な件名です。件名を終了してから新規作成してください。',
                'subjects.limitReachedFoundation': 'FOUNDATIONプランは会話ごとに最大5件の有効な件名です。件名を終了してから新規作成してください。',
                'subjects.activeLimitsLine': '有効な件名：{current} / {max}',
                'subjects.closedListTitle': '終了した件名',
                'subjects.viewClosed': '終了した件名を表示',
                'subjects.noClosedSubjects': '終了した件名はありません。',
                'subjects.reopenSubject': '再開',
                'subjects.reopenedSubjects': '再開した件名',
                "subjects.reopenLimitReached": `subject.ownerOnlyReopen': 'サブジェクトを再度開くことができるのは、サブジェクトを作成した人だけです。`,
                'subjects.ownerOnlyReopen': 'この件名を作成したユーザーのみ再開できます。',
                'subjects.modal.title': '会話の件名',
                'subjects.modal.subtitle': 'この会話の件名を選択または管理します。',
                'subjects.contactLabel': '連絡先：',
                'subjects.ownerOnlyRename': 'トピックを作成した人だけが名前を変更できます。',
                'subjects.ownerOnlyStateChange': 'トピックを作成した人だけが状態を変更できます。',
                'subjects.createdByOther': 'このトピックは相手が作成しました。返信はできますが、名前は変更できません。',
                'subjects.empty': '表示する件名がありません。',
                'subjects.noResults': '件名が見つかりません。',
                'subjects.error.generic': '操作を完了できませんでした。もう一度お試しください。',
                'subjects.error.featureDisabled': 'この環境では件名を利用できません。',
                'subjects.error.duplicateName': '同じ名前のアクティブな件名が既に存在します。',
                'subjects.error.ownerRequired': 'このトピックを変更する権限がありません。',
                'subjects.error.defaultCannotRename': '「一般」の件名は変更できません。',
                'subjects.error.defaultCannotFinish': '「一般」の件名は完了にできません。',
                'subjects.current': '件名',
                'subjects.change': '件名を変更',
                'subjects.currentLabel': '件名：',
                'subjects.changeSubject': '件名を変更',
                'subjects.closedCannotSend': 'この件名は終了しています。新しいメッセージを送るには再度開いてください。',
                'subjects.selectBeforeSend': 'モーダルで件名を選ぶとメッセージを表示・送信できます。',
                'subjects.loadingMessages': 'この件名のメッセージを読み込み中…',
                'subjects.messageFilterError': 'この件名のメッセージを読み込めませんでした。',

                // Tags
                "tags.etiquetas": "タグ",
                "tags.manageTitle": "タグの管理",
                "tags.manage": "🏷️のタグ",
                "tags.allTags": "すべてのタグ",
                "tags.confirmDelete": "このタグを削除しますか?",
                "tags.tagNamePlaceholder": "タグ名",
                "tags.create": "作成する",
                "tags.noTags": "タグはありません。上に作成します。",
                "tags.save": "保存",
                "tags.edit": "編集",
                "tags.delete": "消去",
                "tags.assignTo": "に割り当てる",
                "tags.noTagsToAssign": "使用可能なタグがありません。まずそれらを作成してください。",
                // Templates
                "templates.selectTitle": "テンプレート",
                "templates.noTemplates": "テンプレートはありません。上に作成します。",
                "templates.manage": "テンプレートの管理",
                "templates.confirmDelete": "このテンプレートを削除しますか?",
                "templates.manageTitle": "テンプレートの管理",
                "templates.titlePlaceholder": "テンプレートのタイトル",
                "templates.bodyPlaceholder": "テンプレートメッセージを書きます...",
                "templates.create": "テンプレートの作成",
                "templates.save": "保存",
                "templates.edit": "編集",
                "templates.delete": "消去",
                // Tags (added)
                "tags.bgColor": "背景色",
                "tags.textColor": "文字の色",
                "tags.selectTag": "タグを選択してください",
                // Web Push notifications
                "settings.webPushSection": "システム通知（Webプッシュ/PWA）",
                "settings.webPushDescription": "アプリがバックグラウンドにあるとき、またはモバイルで閉じているときにアラートを許可します。ビルド内の VAPID 公開キー (VITE_VAPID_PUBLIC_KEY) とサーバー キーが必要です。ブラウザに許可を与え、このデバイスを登録します。",
                "settings.webPushButton": "プッシュ通知を有効にする",
                "settings.webPushRegistering": "登録中…",
                "settings.webPushState.granted": "許可が与えられました。 VAPID が構成されている場合、サブスクリプションはサーバーに送信されました。",
                "settings.webPushState.denied": "許可が拒否されました。ブラウザの設定でこのサイトの通知を有効にしてください。",
                "settings.webPushState.default": "ボタンをタップして許可を要求し、このデバイスを登録します。",
                "settings.webPushState.unsupported": "このブラウザは Web プッシュをサポートしていません。",
                "settings.webPushVapidMissing": "このフロントエンド ビルドには VITE_VAPID_PUBLIC_KEY がありません。プッシュ サブスクリプションを完了できません。",
                ...PRESET_LOCALES.ja,
                "auth.login.clear_password_lock_after_reset": "すでにパスワードを変更しています (例: 別のデバイスで)",
                "auth.signup_disabled": "この環境では新規アカウントの登録が一時的に無効になっています。",
                "auth.reset_user_not_found": "そのメールに関連付けられたアカウントは見つかりませんでした。スペルが正しいことを確認するか、新しいアカウントを作成してください。",
                "account.not_found": "アカウントが見つかりません。",
                "auth.pending_activation.title": "アカウントのアクティブ化が保留中です",
                "auth.pending_activation.body": "あなたのアカウントはまだアクティブ化されていません。電子メールをチェックし、ArChat に入る登録を確認してください。",
                "auth.pending_activation.back_to_login": "ログインに戻る",
                "auth.pending_activation.support_prefix": "助けが必要ですか?サポートに連絡してください:",
                "auth.pending_activation.support_email": "info@archat.com.ar",
                "auth.pending_activation.email_label": "アクティベーションを再送信するための電子メール",
                "auth.pending_activation.email_placeholder": "tu@email.com",
                "auth.pending_activation.email_required": "登録した電子メールを入力してアクティベーションを再送信します。",
                "auth.pending_activation.sent_title": "アクティベーションメールが送信されました",
                "auth.pending_activation.sent_body": "電子メールが保留中のアカウントに対応する場合は、新しいアクティベーション リンクを送信します。受信箱を確認し、スパムメールやジャンクメールも確認してください。",
                "auth.pending_activation.soft_error_title": "再送信はできません",
                "auth.pending_activation.soft_error_body": "現時点では再送信を処理できませんでした。数分後にもう一度試すか、info@archat.com.ar までご連絡ください。",
                "auth.pending_activation.resend_again": "再度再送信",
                "menu.plans": "予定",
                "files.title": "私のファイル",
                "files.filter_all": "全て",
                "files.filter_sent": "送信済み",
                "files.filter_received": "受け取った",
                "files.filter_images": "画像",
                "files.filter_documents": "書類",
                "files.col_name": "名前",
                "files.col_size": "サイズ",
                "files.col_date": "日付",
                "files.col_direction": "監督",
                "files.col_actions": "アクション",
                "files.sent": "📤送信済み",
                "files.received": "📥受け取りました",
                "files.download": "放電",
                "files.delete_for_me": "私のために削除してください",
                "files.delete_confirm_title": "ファイルの削除",
                "files.delete_confirm_message": "このファイルはアカウントから削除されます。相手の場合は削除されません。続く？",
                "files.empty": "ファイルがありません。",
                "files.error_loading": "ファイルのアップロード中にエラーが発生しました。",
                "files.load_more": "さらにロードする",
                "message.status.sending": "送信中…",
                "message.status.failed": "送信されませんでした",
                "message.status.sent": "送信済み",
                "message.status.delivered": "納品済み",
                "message.status.read": "読む",
                "home.public_nav.pricing": "価格",
                "home.public_nav.aria": "メインサイトのナビゲーション",
                "home.public_footer.aria": "法的リンク",
                "home.pricing_link": "プランと料金",
                "publicPricing.nav.back_home": "← ホーム",
                "publicPricing.title": "プランと料金",
                "publicPricing.subtitle": "ArChat サブスクリプション エンジンに対する透過的で調整された制限。国際チェックアウト用の米ドルでの商業価格 (例: Paddle)。",
                "publicPricing.commercial_note": "機能境界は PlanConstants/PlanResolver から取得されます。あなたのアカウントはデータベース内の plan_limits を適用できます。マーチャントの課金では、示されているように米ドル価格の Paddle (または ArChat によって正式に指定された他のプロセッサ) が使用されます。",
                "publicPricing.plan.free": "FREE",
                "publicPricing.plan.foundation": "FOUNDATION",
                "publicPricing.plan.pro": "PRO",
                "publicPricing.price.free": "USD 0 / mes",
                "publicPricing.price.foundation": "USD {price} / mes",
                "publicPricing.price.pro": "USD {price} / mes",
                "publicPricing.same_limits_pro": "PRO（プレミアム契約）と同じ技術制限。",
                "publicPricing.same_limits_foundation": "FOUNDATION（プレミアム契約）と同じ技術制限。",
                "publicPricing.badge.foundation": "Programa Founder",
                "publicPricing.badge.pro": "Recomendado",
                "publicPricing.free.b1": "アカウントごとに月あたり 30,000 文字。",
                "publicPricing.free.b2": "ユーザーあたり最大 2 つの連絡先。アカウントあたり最大 2 つのアクティブな会話。",
                "publicPricing.free.b3": "付属品や保管スペースはありません。データのエクスポートなし。",
                "publicPricing.free.b4": "メッセージ履歴は最大 30 日間。ユーザーごとに 1 つのデバイス。",
                "publicPricing.free.b5": "34 メッセージ/日、1,000 メッセージ/月 (テナント)。 1 日あたり最大 20 件の招待。",
                "publicPricing.premium.b1": "アカウントあたり月あたり 300,000 文字。ユーザーあたり最大 100 件の連絡先。",
                "publicPricing.premium.b2": "無制限の会話とチャット (テナント)。メッセージ数は 1,667 件/日、50,000 件/月。",
                "publicPricing.premium.b3": "最大 50 MB のストレージ (テナント)。ユーザーあたり最大 3 台のデバイス。",
                "publicPricing.premium.b4": "無制限の招待 (テナント)。計画に従ってエクスポート、自動翻訳、ファイルを作成します。",
                "publicPricing.premium.b5": "FOUNDATION: PRO と同じ技術契約に加えて、Founder プログラム (150 か所)。 PRO: プレミアムスタンダード。",
                "publicPricing.foundation.founder_note": "ファウンダー商用プログラム: {スロット} の場所の数が限られています (計画の概要を参照)。サブスクリプションがアクティブ化されると、同じ PRO 制限が適用されます。",
                "publicPricing.cta.start_free": "無料アカウントを作成する",
                "publicPricing.cta.register_paid": "アカウントを作成する",
                "publicPricing.paddle_hint": "充電が有効になっている場合、選択したプロセッサーでのチェックアウトはアプリケーション内で完了します。",
                "publicPricing.legal.nav_label": "法律上の",
                "publicPricing.legal.terms": "利用規約",
                "publicPricing.legal.privacy": "プライバシーポリシー",
                "publicPricing.legal.refund": "返金ポリシー",
                "profile.security.privacy_note": "アカウントのプライバシーとセキュリティを管理します。",
                "profile.security.sessions_title": "アクティブなセッション",
                "profile.security.current": "現在のセッション",
                "profile.plan.foundation.description": "FOUNDATION プラン (Founder): PRO と同じプレミアム使用で、Founder プログラムと限られたスペース (150 席) が含まれます。",
                "billing.view_plans": "プランを見る",
                "billing.paddle.cancel_via_portal": "サブスクリプションをキャンセルする",
                "billing.paddle.test_access_denied_body": "このサーバーでは、課金操作が制限されています（テストモードまたはテストリスト）。すでに実際のアカウントで支払いを行っている場合は、運用環境ですべてのユーザーに支払いを許可するか (PAYMENTS_ALLOW_ALL_BILLING_USERS など)、その制限を無効にする必要があります。サポートにお問い合わせください。",
                "attachment.storage_insufficient_precheck.title": "スペースが不十分です",
                "attachment.storage_insufficient_precheck.message": "ファイルの重さは {fileSizeMb} MB ですが、使用できるのは {availableMb} MB のみです。スペースを解放するか、継続するための計画を改善してください。",
                "attachment.files_disabled.title": "プランの制限",
                "attachment.files_disabled.message": "現在のプランにはファイル送信は含まれていません。継続するために計画を改善します。",
                "contacts.viewContactInfo": "連絡先の詳細を表示",
                "contacts.contactInfoTitle": "連絡先の詳細",
                "contacts.phone": "電話",
                "contacts.bio": "バイオグラフィー",
                "contacts.notProvided": "情報が無い",
                "contacts.unread.badge": "未読メッセージ",
                "dashboard.recentInbound.title": "最後に受信したメッセージ",
                "dashboard.recentInbound.empty": "最近受信したメッセージはありません。",
                "dashboard.recentInbound.error": "メッセージを読み込めませんでした。",
                "dashboard.recentInbound.previewPhoto": "写真",
                "dashboard.recentInbound.previewFile": "アーカイブ",
                "dashboard.recentInbound.previewPdf": "PDF",
                "dashboard.recentInbound.previewUnavailable": "メッセージは利用できません",
                "dashboard.recentInbound.readTitle": "読む",
                "dashboard.recentInbound.unreadTitle": "未読",
                "dashboard.recentConversations.title": "最近の会話",
                "dashboard.recentConversations.empty": "表示する会話はありません。",
                "dashboard.recentConversations.error": "会話を読み込めませんでした。",
                "dashboard.plan.foundation": "FOUNDATION",
                "plan.errors.translationNotAllowed.title": "翻訳は利用できません",
                "plan.errors.translationNotAllowed.message": "現在のプランには、言語間の自動翻訳は含まれていません。",
                "plan.errors.translationNotAllowed.solution": "自動翻訳を使用するには、プランをアップグレードしてください。",
                "billing.subscription.cancel_scheduled_date": "あなたのサブスクリプションは {{date}} にキャンセルされる予定です。それまではプランを引き続き使用できます。",
                "billing.subscription.cancel_scheduled_badge": "{{日付}}にキャンセルされました",
                "billing.scheduled.plan_after_cancel_label": "期間終了時の計画:",
                "billing.scheduled.plan_free": "FREE (gratuito)",
                "billing.scheduled.plan_foundation": "FOUNDATION",
                "billing.scheduled.switch_to_foundation": "ファンデーションに変更",
                "billing.scheduled.switch_to_free": "無料に変更",
                "billing.scheduled.foundation_full_title": "ファンデーションは利用できません",
                "billing.scheduled.foundation_full_message": "現時点では利用可能な FOUNDATION スポットはありません。期間が終了すると、プランは無料になります。",
                "billing.scheduled.saving": "保存中...",
                "billing.scheduled.error_title": "プラン変更時のエラー",
                "billing.scheduled.error_generic": "予定されていた計画は変更できませんでした。もう一度やり直してください。",
                "billing.cancel_scheduled.title": "予定キャンセル",
                "billing.cancel_scheduled.desc": "サブスクリプションは {{date}} にキャンセルされます。それまでは現在のプランを引き続き使用できます。",
                "billing.cancel_scheduled.no_new_plan_until_end": "このサブスクリプションの有効期限が切れるまで、別のプランを契約することはできません。",
                "billing.cancel_scheduled.free_fallback": "プランを更新しない場合、アカウントは対応する制限付きで無料で継続されます。",
                "billing.cancel_scheduled.profile_deactivation_hint": "プロフィールからプラットフォームの購読を解除することもできます。",
                "billing.cancel_scheduled.default_free": "期間終了時：無料",
                "google.missing_client_id": "このビルドでは Google サインインは使用できません: VITE_GOOGLE_CLIENT_ID (または __ARCHAT_TENANT_CONFIG__ のテナントごとの googleClientId) がありません。",
                "reviews.title": "アーチャットのレビュー",
                "reviews.create_title": "ArChat をどう評価しますか?",
                "reviews.edit_title": "レビューを編集する",
                "reviews.comment_placeholder": "あなたの経験について教えてください（任意）...",
                "reviews.submit_btn": "レビューを送信する",
                "reviews.update_btn": "アップデート",
                "reviews.thank_you": "レビューいただきありがとうございます！",
                "reviews.submitted_message": "あなたの意見は私たちの改善に役立ちます。",
                "reviews.error_select_rating": "評価を選択してください",
                "reviews.error_generic": "レビュー送信エラー",
                "reviews.prompt_message": "ArChatが好きですか？レビューを残してください！",
                "reviews.rate_now": "資格を得る",
                "reviews.later": "後で",
                "reviews.write_review": "レビューを書く",
                "reviews.edit_my_review": "レビューを編集する",
                "reviews.no_reviews": "まだレビューはありません。最初になろう！",
                "reviews.review_singular": "レビュー",
                "reviews.review_plural": "レビュー",
                "reviews.verified": "確認済み",
                "reviews.anonymous": "匿名",
                "files.storageUsed": "使用済みスペース",
                "files.planQuota": "プランのクォータ",
                "files.availableStorage": "利用可能",
                "files.usagePercent": "使用済み",
                "files.unlimited": "無制限",
                "files.sentBy": "送信者",
                "files.unknownUser": "ユーザー",
};


